import {
  getServerValidation,
  fetchSelectOptions,
  fetchAPIData,
  getAutofillValues,
  getFilePreview,
  uploadFile as postFile,
  FetchPOSPlan,
  FetchPOSOnboardDetails
} from '../api'
import {
  isNoRadioSelected,
  getValidationsResult,
  posProducts,
  CONTEXT_ROOT
} from '../../utils'
import { updateWidget } from './widgetsActions'
import { getAddressComponents,getDocumentoRulesComponent } from './../static/addressStatic'
import { getPromoCodeComponent, getPromotionalComponent } from './../static/promoCodeStatic'
import {
  dealActionToken,
  ActionToken,
  stepCallback,
  hideLoading,
  enableBtn,
  showAlert,
  updateUserComponent,
  digitalSignCheckCall,
  getContractList,
  updateTitolareList,
  updateDiFarmaComponent,
  Patrimonio_CheckBoxes,
  Patrimonio_CheckBoxes_RBG1,
  Patrimonio_CheckBoxes_RBG2,
  Patrimonio_CheckBoxes_RBG3,
  Patrimonio_CheckBoxes_RBG4,
  Patrimonio_CheckBoxes_RBG5,
  Patrimonio_CheckBoxes_RBG6,
  Patrimonio_CheckBoxes_RBG7,
  Patrimonio_CheckBoxes_RBG8,
  Patrimonio_CheckBoxes_RBG9,
  Patrimonio_CheckBoxes_RBG10,
  Patrimonio_RadioButtons,
  PatrimonioCheckBoxesIds
} from './stepActions'
import { uniqBy, union } from 'lodash'
import uuid from 'uuid'
import * as Model from './../stateExtension'
// import qs from 'qs'

/**
 * Actions you can make on components
 * @module  {Actions} componentActions
 */
export const UPDATE_ALL_COMPONENTS = '@@components/UPDATE_ALL'
export const UPDATE_COMPONENT = '@@components/UPDATE'
export const QUESTIONARIO_COMPONENT = '@@components/QUESTIONARIO'
export const SIDE_UPDATE_COMPONENT = '@@components/SIDE_UPDATE'
export const VALIDATE_COMPONENT_SUCCESS = '@@components/VALIDATION_SUCCESS'
export const VALIDATE_COMPONENT_FAILED = '@@components/VALIDATION_FAILED'
export const SIDE_VALIDATE_COMPONENT_SUCCESS =
  '@@components/SIDE_VALIDATION_SUCCESS'
export const SIDE_VALIDATE_COMPONENT_FAILED =
  '@@components/SIDE_VALIDATION_FAILED'
export const SERVER_VALIDATE_COMPONENT_SUCCESS =
  '@@components/SERVER_VALIDATION_SUCCESS'
export const SERVER_VALIDATE_COMPONENT_FAILED =
  '@@components/SERVER_VALIDATION_FAILED'
export const AUTOFILL_COMPONENT_START = '@@components/AUTOFILL_START'
export const AUTOFILL_COMPONENT_DONE = '@@components/AUTOFILL_DONE'
export const AUTOFILL_COMPONENT_FAILED = '@@components/AUTOFILL_FAILED'
export const AUTOFILL_COMPONENT_DISCARDED = '@@components/AUTOFILL_DISCARDED'

/**
 * Given the object toggleVisibility options and an array of widgets
 * or components return the update body required to update the component/widget visibility.
 * @private
 *
 * @param  {bool} isVisible     If the related component or widget must be visible or not
 * @param  {Array} array        The whole array of widgets or components
 * @param  {string} field       The related component or widget id
 * @return {Object}             The update body
 */
const getVisibilityUpdatedBody = (isVisible, array, field) => {
  const updateBody = {}
  if (isVisible) {
    updateBody.status = array[field].status.filter(e => e !== 'hidden')
    updateBody.active = true
  } else if (!isVisible) {
    updateBody.status = union(array[field].status, ['hidden'])
    updateBody.active = false

    if (array[field].type === 'radio') {
      updateBody.value =
        array[field].status.indexOf('selected') > -1 ? 'selected' : ''
    }
    // if(array[field].status.indexOf(''))
  } /*else {
    if (array[field].status.indexOf('hidden') >= 0) {
      updateBody.status = array[field].status.filter(e => e !== 'hidden')
      updateBody.active = true
    } else {
      updateBody.status = union(array[field].status, ['hidden'])
      updateBody.active = false

      if (array[field].type === 'radio') {
        updateBody.value =
          array[field].status.indexOf('selected') > -1 ? 'selected' : ''
      }
    }
  }*/
  return updateBody
}

export const isWidgetsActive = (widget, fields) => {
  return widget.components.some(n => {
    //const cName = `${widget.name}-${c.name}`
    const c = Model.COMPONENTS[n]
    return fields.every(f => f !== n) && c && c.active
  })
}

/**
 * Notify components that they need to validate again
 *
 * @param  {type} options     Validation options
 * @param  {type} components  The full state components
 * @return {Function}         Calls the validateComponent function
 */
export const toggleVisibility = (options, component) => (
  dispatch,
  getState
) => {
  const { components, widgets, step, product } = getState()
  let visibility_ = true
  if (component.linkId || component.widgetName) {
    const isExist =
      !component.widgetName && isLinkExist(component.linkId, components)
    if (isExist) {
      visibility_ = true
    } else if (component.type === 'selectbox' || component.type === 'text') {
      if (component.linkValues) {
        visibility_ = component.linkValues.some(v => v === component.value)
      } else {
        visibility_ =
          component.linkValue && component.linkValue === component.value
      }
    } else if (component.type === 'radio' || component.type === 'checkbox') {
      visibility_ = component.value === 'selected'
    }
  }
  Object.keys(options).forEach(visibility => {
    let isVisible = false
    const fields = options[visibility] && options[visibility].fields
    if (fields && fields.length > 0) {
      fields.forEach(field => {
        const isComponent = field.indexOf('-') > -1
        if (field === 'SZ0025') {
          isVisible = 'true'
        } else {
          if (
            isComponent ||
            (step.number && !step.name.startsWith('Personalizza'))
          ) {
            isVisible = visibility === 'show' ? visibility_ : !visibility_
            //isVisible = visibility === 'show' && visibility_
          } else {
            const widget = widgets[field]
            if (widget) {
              if (visibility === 'show') {
                if (visibility_) {
                  isVisible =
                    widget.active || fields.some(f => f.startsWith(field + '-'))
                } else {
                  isVisible =
                    widget.active && isWidgetsActive(widgets[field], fields)
                }
              } else {
                if (visibility_) {
                  isVisible =
                    widget.active && isWidgetsActive(widgets[field], fields)
                } else {
                  isVisible =
                    widget.active || fields.some(f => f.startsWith(field + '-'))
                }
              }
            }
          }
        }
        if (!!components[field]) {
          const updateBody = getVisibilityUpdatedBody(
            isVisible,
            components,
            field
          )
          dispatch(
            updateComponent(field, updateBody, {
              collateral: true,
              avoidAutofill: true
            })
          )
        } else if (!!widgets[field]) {
          const updateBody = getVisibilityUpdatedBody(isVisible, widgets, field)
          dispatch(updateWidget(field, updateBody, { collateral: true }))

          //Rewamp of whole digital contracts in last step (All flows)	
          if (field === 'DOCUMENTO_2' || field === 'SELFIE') {
            Object.keys(components)
              .filter(c => components[c].id.startsWith(`${field}-`) &&
                c !== 'DOCUMENTO_2-PERMESSO_SOGGIORNO' &&
                c !== 'DOCUMENTO_2-SECONDDOCUMENTRULE1' &&
                c !== 'DOCUMENTO_2-SECONDDOCUMENTRULE2' &&
                c !== 'DOCUMENTO_2-SECONDDOCUMENTRULE3' &&
                c !== 'DOCUMENTO_2-TIPO_DOCUMENTO')
              .forEach(k => {
                isVisible ? dispatch(updateComponent(k, { status: [] },
                  { collateral: true, avoidAutofill: true })) :
                  dispatch(updateComponent(k, { status: ['hidden'] },
                    { collateral: true, avoidAutofill: true }))
              })
          }

        }
      })
    }
  })
}

/**
 * Updates all the components
 *
 * @param {Object} components      The updated components
 * @return {Function}              Dispatches an UPDATE_ALL_COMPONENTS action
 */
export const updateAllComponents = components => {
  return {
    type: UPDATE_ALL_COMPONENTS,
    components
  }
}

/**
 * Validates a component by calling an API endpoint
 *
 * @param  {Object} component     The component to validate
 * @param  {string} components    The component new value
 * @return {Promise}              Dispatches an UPDATE_WIDGETS action
 */
const serverValidateComponent = component => (dispatch, getState) => {
  if (!component.validations.hasOwnProperty('url') || component.value === '')
    return

  const { components } = getState()

  const token = new ActionToken(`${component.id}.serverValidateComponent`, true)

  const body = {}
  let needValidation = false
  if (component.validations.fields.length) {
    component.validations.fields.forEach(input => {
      if (!!components[input]) {
        if (
          !!component.validations.mapping &&
          !!component.validations.mapping[input]
        ) {
          body[component.validations.mapping[input]] = components[input].value
        } else {
          body[components[input].name.toLowerCase()] = components[input].value
          if (components[input].value !== components[input].validValue)
            needValidation = true
          if(components[input].id === 'PROMO-PromoCode') needValidation = true
        }
      }
    })
  } else {
    const fields = component.validations.fields
    Object.keys(fields).forEach(key => {
      if (fields[key].fieldName && components[key]) {
        body[fields[key].fieldName] = components[key].value
        if (components[key].value !== components[key].validValue)
          needValidation = true
        if(components[key].id === 'PROMO-PromoCode') needValidation = true
      }
    })
  }

  // if (
  //   !component.validations.results ||
  //   !component.validations.results[qs.stringify(body)]
  // ) {
  if (needValidation) {
    dispatch(dealActionToken(token))
    getServerValidation(component, body).then(delta => {
      if (delta.status.indexOf('success') > -1) {
        if(component.id==='CELLULARE-NUM_CELLULARE')
        {
          dispatch(
            updateComponent('CELLULARE-CODICE_CELLULARE', {
              isDisabled: false
            },{ avoidValidation: true })
          )
        }
        if (component.validations.fields.length) {
          component.validations.fields.forEach(input => {
            if (!!components[input]) {
              if (
                !!component.validations.mapping &&
                !!component.validations.mapping[input]
              ) {
                // components[input].validValue = components[input].value
              } else {
                components[input].validValue = components[input].value
              }
            }
          })
        } else {
          const fields = component.validations.fields
          Object.keys(fields).forEach(key => {
            if (fields[key].fieldName && components[key]) {
              components[key].validValue = components[key].value
            }
          })
        }
      }
      if(component.id==='CELLULARE-CODICE_CELLULARE' && delta.status.indexOf('error')>-1)
        {
          let updateBody={otpbtnDisabled:false}
          dispatch(
            updateComponent('CELLULARE-NUM_CELLULARE', {
              otpbtnDisabled: false
            },{ avoidValidation: true })
          )
           // dispatch({type:UPDATE_COMPONENT,component:{...updateBody,id: 'CELLULARE-NUM_CELLULARE'}, avoidValidation: true })
        }
      dispatch({
        type:
          delta.status.indexOf('error') > -1
            ? SERVER_VALIDATE_COMPONENT_FAILED
            : SERVER_VALIDATE_COMPONENT_SUCCESS,
        component: {
          ...delta,
          status: [
            ...new Set([
              ...component.status.filter(s => s !== 'error'),
              ...delta.status
            ])
          ],
          id: component.id
          // validations: {
          //   ...component.validations,
          //   results: {
          //     ...(component.validations.results || {}),
          //     [qs.stringify(body)]: delta
          //   }
          // }
        }
      })
      dispatch(dealActionToken({ ...token, dispose: true }))
    })
  }
  // } else {
  //   const delta = component.validations.results[qs.stringify(body)]
  //   dispatch({
  //     type:
  //       delta.status.indexOf('error') > -1
  //         ? SERVER_VALIDATE_COMPONENT_FAILED
  //         : SERVER_VALIDATE_COMPONENT_SUCCESS,
  //     component: {
  //       ...delta,
  //       id: component.id
  //     }
  //   })
  // }
}

/**
 * Validates a component pattern
 *
 * @param {Object} componentId      The component to validate
 * @param {Object} options          The component to validate
 * @param {Boolean} options.passTrough      Allows to bypass the validation
 * @param {Boolean} options.evalBlanks      Force validation for blank inputs
 * @param {Boolean} options.collateral      Collateral validation flag
 * @return {Object}                 The validated component
 */
export const validateComponent = (
  componentId,
  { passTrough, evalBlanks, collateral, execLazy } = {}
) => (dispatch, getState) => {
  const { widgets, components, step } = getState()
  if (
    step.name.startsWith('Personalizza') &&
    componentId &&
    componentId.startsWith('CODICE_FISCALE')
  ) {
    return
  }
  if(componentId==="undefined")
  {
    return
  }
  const component = components[componentId]
    if(componentId==='PROFESSIONE_ATTIVITA-ATTIVITA' || componentId==='PROFESSIONE_ATTIVITA-SETTORE')
    {
      if(!!component.values && component.values.length===0)
      {
      evalBlanks=false
      }
    }
  passTrough = !!passTrough
  passTrough =
    passTrough ||
    (component.validations &&
      (!component.validations.isRequired ||
        !component.validations.hasOwnProperty('default')))
  passTrough =
    passTrough ||
    component.type === 'hidden' ||
    component.status.indexOf('hidden') > -1

  if (component.type === 'radio' && component.status.indexOf('hidden') < 0) {
    const widget = widgets[`${componentId.split('-')[0]}`]
    if (widget && widget.status.indexOf('hidden') < 0) {
      passTrough =
        (passTrough || !!evalBlanks) &&
        !isNoRadioSelected(components, componentId, widget)
    } else {
      passTrough = true
    }
  } else {
    const firstCheckBox = 'SZ0024-SS0049_DM0094_RI0504'
    const secondCheckBox = 'SZ0024-SS0049_DM0094_RI0505'

     /* Titolare Effecttivo checkboxes validations*/
  const Titolare_Effettivo_CheckBoxes = [
    'SZ0024-SS0049_DM0094_RI0500',
    'SZ0024-SS0049_DM0094_RI0501', 
    'SZ0024-SS0049_DM0534_RI0502',
    'SZ0024-SS0049_DM0534_RI0503',
    'SZ0024-SS0049_DM0525_RI0576',
    'SZ0024-SS0049_DM0525_RI0577'
]
const checkboxGroup1=[
  'SZ0024-SS0049_DM0094_RI0500',
    'SZ0024-SS0049_DM0094_RI0501'
]
const checkboxGroup2=[
  'SZ0024-SS0049_DM0534_RI0502',
    'SZ0024-SS0049_DM0534_RI0503'
]
const checkboxGroup3=[
  'SZ0024-SS0049_DM0525_RI0576',
    'SZ0024-SS0049_DM0525_RI0577'
]

     //Fix for Informazioni-compagine questionnaire checkbox validation
    const checkbox1_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI0121'
    const checkbox2_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1058'
    const checkbox3_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1059'
    const checkbox4_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1060'
    const checkbox5_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1061'
    const checkbox6_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1056'
    const checkbox7_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI0126'
    const checkbox8_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI0381'

    const Informazioni_compagine_checkboxes = [
      'SZ0023-SS0048_DM0089_RI0121',
      'SZ0023-SS0048_DM0089_RI1058', 
      'SZ0023-SS0048_DM0089_RI1059',
      'SZ0023-SS0048_DM0089_RI1060',
      'SZ0023-SS0048_DM0089_RI1061',
      'SZ0023-SS0048_DM0089_RI1056',
      'SZ0023-SS0048_DM0089_RI0126',
      'SZ0023-SS0048_DM0089_RI0381'
  ]
  const  Ulteriori_info_CheckBoxes=[
    'SZ0022-SS0208_DM0849_RI0947',
    'SZ0022-SS0208_DM0849_RI0948',
    'SZ0022-SS0208_DM0849_RI0949'
  ]
  const Altre_informazioni_Checkboxes=[
    'SZ0011-SS0230_DM0886_RI0989',
    'SZ0011-SS0230_DM0886_RI0990',
    'SZ0011-SS0230_DM0886_RI0991'
  ]
  // const Patrimonio_CheckBoxes=[
  //   'SZ0010-SS0221_DM0864_RI0059',
  //   'SZ0010-SS0221_DM0864_RI0060', 
  //   'SZ0010-SS0221_DM0864_RI0061', 
  //   'SZ0010-SS0221_DM0864_RI0062', 
  //   'SZ0010-SS0221_DM0864_RI0063',
  //   'SZ0010-SS0221_DM0864_RI0064', 
  //   'SZ0010-SS0221_DM0864_RI0065']
    const checkbox1_SZ0010_SS0221 ='SZ0010-SS0221_DM0864_RI0059'
    const checkbox2_SZ0010_SS0221 ='SZ0010-SS0221_DM0864_RI0060'
    const checkbox3_SZ0010_SS0221 ='SZ0010-SS0221_DM0864_RI0061'
    const checkbox4_SZ0010_SS0221 ='SZ0010-SS0221_DM0864_RI0062'
    const checkbox5_SZ0010_SS0221 ='SZ0010-SS0221_DM0864_RI0063'
    const checkbox6_SZ0010_SS0221 ='SZ0010-SS0221_DM0864_RI0064'
    const checkbox7_SZ0010_SS0221 ='SZ0010-SS0221_DM0864_RI0065'
    const checkbox1_SZ0011_SS0230 = 'SZ0011-SS0230_DM0886_RI0989'
    const checkbox2_SZ0011_SS0230 = 'SZ0011-SS0230_DM0886_RI0990'
    const checkbox3_SZ0011_SS0230 = 'SZ0011-SS0230_DM0886_RI0991'
    const checkbox1_SZ0022_SS0208 = 'SZ0022-SS0208_DM0849_RI0947'
    const checkbox2_SZ0022_SS0208 = 'SZ0022-SS0208_DM0849_RI0948'
    const checkbox3_SZ0022_SS0208 = 'SZ0022-SS0208_DM0849_RI0949'
    const dropProvincia='SZ0016-SS0011_DM0030_RI0103'
    const dropArea='SZ0016-SS0011_DM0031_RI0104'
    const dropPerProvincia='SZ0007-SS0007_DM0030_RI0026'
    const dropPerArea='SZ0007-SS0007_DM0031_RI0027'
    const drpNazioneFiduciaria='SZ0023-SS0027_DM0536_RI0609'
    const drpNazioneTrust='SZ0023-SS0027_DM0537_RI0610'
    const drpNazioneSociet='SZ0023-SS0027_DM0538_RI0611'
    const drpNazionecapogruppo='SZ0023-SS0027_DM0092_RI0102'
    const drpNazioneFondazione ='SZ0023-SS0027_DM0535_RI0608'
    //const drpprodotto="SZ0144-SS0237_DM0959_RI0791";
    if (
      component.type === 'checkbox' &&
      (component.id === firstCheckBox || component.id === secondCheckBox)
    ) {
      const otherCheckBox =
        component.id === firstCheckBox ? secondCheckBox : firstCheckBox
      passTrough =
        passTrough ||
        component.value === 'selected' ||
        (components[otherCheckBox].active &&
          components[otherCheckBox].value === 'selected')
    } 
     //Fix for Informazioni-compagine questionnaire checkbox validation
    else if (
      component.type === 'checkbox' &&
      (component.id === checkbox1_SS0048_DM0089 ||
         component.id === checkbox2_SS0048_DM0089 ||
         component.id === checkbox3_SS0048_DM0089 ||
         component.id === checkbox4_SS0048_DM0089 ||
         component.id === checkbox5_SS0048_DM0089 ||
         component.id === checkbox6_SS0048_DM0089 ||
         component.id === checkbox7_SS0048_DM0089 ||
         component.id === checkbox8_SS0048_DM0089 
         )
    ) {
    
      //debugger;
      let isInfoCampgneChecked = false;
      Informazioni_compagine_checkboxes.forEach(chbox => {  
        isInfoCampgneChecked = isInfoCampgneChecked || 
                               (!!components[chbox] && components[chbox].active &&
                                components[chbox].value === 'selected')

        });  
        passTrough = passTrough || component.value === 'selected' || isInfoCampgneChecked

    }
    else if ( component.type === 'checkbox' && 
      (component.id === checkbox1_SZ0022_SS0208 ||
      component.id === checkbox2_SZ0022_SS0208 ||
      component.id === checkbox3_SZ0022_SS0208)) {
      let isUlterioriInfoCheckBoxes=false
      Ulteriori_info_CheckBoxes.forEach(chbox => {  
        isUlterioriInfoCheckBoxes = isUlterioriInfoCheckBoxes || (components[chbox].active && components[chbox].value === 'selected')
        });
        passTrough = passTrough || component.value === 'selected' || isUlterioriInfoCheckBoxes
    }
    else if ( component.type === 'checkbox' && 
      (component.id === checkbox1_SZ0011_SS0230 ||
      component.id === checkbox2_SZ0011_SS0230 ||
      component.id === checkbox3_SZ0011_SS0230)) {
      let altreInformazioniCheckboxes=false
      Altre_informazioni_Checkboxes.forEach(chbox => {  
        altreInformazioniCheckboxes = altreInformazioniCheckboxes || (components[chbox].active && components[chbox].value === 'selected')
        });
        passTrough = passTrough || component.value === 'selected' || altreInformazioniCheckboxes
    }
    else if (component.type === 'checkbox' && Patrimonio_CheckBoxes.indexOf(component.id) > -1) {
      let patrimonioCheckBoxes = false
      Patrimonio_RadioButtons.forEach(radiobtn => {
        if (components[radiobtn].value === 'selected') {
          if (radiobtn === 'SZ0010-SS0212_DM0855_RI0937') {
            Patrimonio_CheckBoxes_RBG1.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }

          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0938') {
            Patrimonio_CheckBoxes_RBG2.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0939') {
            Patrimonio_CheckBoxes_RBG3.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0940') {
            Patrimonio_CheckBoxes_RBG4.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0941') {
            Patrimonio_CheckBoxes_RBG5.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0942') {
            Patrimonio_CheckBoxes_RBG6.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0943') {
            Patrimonio_CheckBoxes_RBG7.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0944') {
            Patrimonio_CheckBoxes_RBG8.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0945') {
            Patrimonio_CheckBoxes_RBG9.forEach(chbox => {
              patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
            })
          }
          // else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0946') {
          //   Patrimonio_CheckBoxes_RBG10.forEach(chbox => {
          //     patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
          //   })
          // }
        }
      })
      passTrough = component.value === 'selected' || patrimonioCheckBoxes
    }
    if ( component.type === 'checkbox' && Titolare_Effettivo_CheckBoxes.indexOf(component.id) > -1) {
      let isTitolareCheckBoxChecked = false;
      if(component.id==='SZ0024-SS0049_DM0094_RI0500' || component.id==='SZ0024-SS0049_DM0094_RI0501')
      {
        let isTitolareCheckBoxCheckedGR1=false
      checkboxGroup1.forEach(chbox => {  
        isTitolareCheckBoxCheckedGR1 = isTitolareCheckBoxCheckedGR1 || (components[chbox].active && components[chbox].value === 'selected')
        });
        isTitolareCheckBoxChecked=isTitolareCheckBoxCheckedGR1
      }
        else if(component.id==='SZ0024-SS0049_DM0534_RI0502' || component.id==='SZ0024-SS0049_DM0534_RI0503')
        {
          let isTitolareCheckBoxCheckedGR2=false
          checkboxGroup2.forEach(chbox => {  
            isTitolareCheckBoxCheckedGR2 = isTitolareCheckBoxCheckedGR2 || (components[chbox].active && components[chbox].value === 'selected')
    
            }); 
            isTitolareCheckBoxChecked=isTitolareCheckBoxCheckedGR2
        }  
        else if(component.id==='SZ0024-SS0049_DM0525_RI0576' || component.id==='SZ0024-SS0049_DM0525_RI0577')
        {
          let isTitolareCheckBoxCheckedGR3=false
          checkboxGroup3.forEach(chbox => {  
            isTitolareCheckBoxCheckedGR3 = isTitolareCheckBoxCheckedGR3 || (components[chbox].active && components[chbox].value === 'selected')
    
            });
            isTitolareCheckBoxChecked=isTitolareCheckBoxCheckedGR3
        }
        passTrough = passTrough || component.value === 'selected' || isTitolareCheckBoxChecked
    }
    else if(component.type==='selectbox' && (component.id===dropProvincia || component.id===dropArea))
    {
   const otherDropBox=component.id===dropProvincia ?dropArea:dropProvincia
   passTrough =
   passTrough ||
   (component.value !== 'Seleziona' &&  component.value !== '')||
   (components[otherDropBox].active &&
    components[otherDropBox].value !== 'Seleziona' &&  components[otherDropBox].value !== '')
    }
    else if (component.type === 'selectbox' && (component.id === drpNazioneFiduciaria || component.id === drpNazioneTrust || component.id === drpNazioneSociet || component.id === drpNazionecapogruppo || component.id === drpNazioneFondazione))
    {
      passTrough =
        passTrough ||
        (component.value !== 'Seleziona' && component.value !== '')
    }
    else if(component.type==='selectbox' && (component.id===dropPerProvincia || component.id===dropPerArea))
    {
   const otherDropBox=component.id===dropPerProvincia ?dropPerArea:dropPerProvincia
   passTrough =
   passTrough ||
   (component.value !== 'Seleziona' &&  component.value !== '')||
   (components[otherDropBox].active &&
    components[otherDropBox].value !== 'Seleziona' &&  components[otherDropBox].value !== '')
    }
    else {
      const widget = widgets[`${componentId.split('-')[0]}`]
      if (!!widget && widget.status.indexOf('hidden') < 0) {
        if (!evalBlanks) {
          passTrough = passTrough || component.value === ''
        }
      } else {
        passTrough = true
      }
    }
  }

  const updateBody = {}

  const validationResult = getValidationsResult({ component, passTrough })

  if (passTrough || validationResult.result) {
    updateBody.status = component.status.filter(e => e !== 'error')
    updateBody.errorMessage = []
    dispatch({
      type: !!collateral
        ? SIDE_VALIDATE_COMPONENT_SUCCESS
        : VALIDATE_COMPONENT_SUCCESS,
      component: { ...updateBody, id: component.id }
    })
    if (
      component.status.indexOf('hidden') < 0 &&
      ((component.validations.skipLazy && !execLazy) ||
        (!component.validations.skipLazy &&
          (!component.validations.lazy || !!execLazy)))
    ) {
      dispatch(serverValidateComponent(component))
    }
    else if(component.id==='CELLULARE-CODICE_CELLULARE')
    {
      dispatch(serverValidateComponent(component))
    }
  } else {
    updateBody.status = union(component.status, ['error'])
    updateBody.errorMessage = [validationResult.errorMessage]

    dispatch({
      type: !!collateral
        ? SIDE_VALIDATE_COMPONENT_FAILED
        : VALIDATE_COMPONENT_FAILED,
      component: { ...updateBody, id: component.id }
    })
  }
}

const getSectionCode = id => id && id.match(/([a-z])+(\d)+/gi)
const FIELD_TYPES = {
  COMBO: 'selectbox',
  RADIO: 'radio',
  LABEL: 'label',
  TEXTBOX: 'text',
  TEXTAREA: 'textarea',
  NUMBER: 'text',
  EMAIL: 'text',
  PHONE: 'text',
  CURRENCY: 'text',
  CHECKBOX: 'checkbox',
  UPLOAD: 'file'
}
const PERSONALIZZA_WIDGETS = ['FLOW_BAR']

const createSpacerComponent = (f, idx, widget) => {
  return {
    iid: `${widget.name}-${f.id}_${idx}`,
    name: `${f.id}_${idx}`,
    type: 'spacer',
    position: idx,
    value: '',
    active: !!(f.properties && !f.properties.hide),
    status: [],
    errorMessage: [],
    extra: true
  }
}

const AddressComponentList = {
  S1S2: ['S1-CAP', 'S1-CITTA', 'S1-INDIRIZZO', 'S1-NAZIONE', 'S1-PROVINCIA'],
  S3S3: ['S3-CAP', 'S3-CITTA', 'S3-INDIRIZZO', 'S3-NAZIONE', 'S3-PROVINCIA'],
  S13S1: [
    'S13-CAP',
    'S13-CITTA',
    'S13-INDIRIZZO',
    'S13-NAZIONE',
    'S13-PROVINCIA'
  ]
}
const updateLinkValueMap = (f, c) => {
  const linkValues = []
  const e = f.events
  if (e && e.onChange && e.onChange.length && e.onChange.length === 1) {
    e.onChange.map(o => {
      const l = o.valueToCheck.length
      if (l === 1) {
        c.linkValue = o.valueToCheck[0]
      } else if (l) {
        c.linkValues = o.valueToCheck
      }
      if (l && (c.linkValue || c.linkValues)) {
        c.toggleVisibility = {}
        if (o.show.length) {
          c.toggleVisibility.show = {
            fields: o.show
          }
        }
        if (o.hide.length) {
          c.toggleVisibility.hide = {
            fields: o.hide
          }
        }
      }
    })
  }
  return linkValues
}
const updateWidgetToggles = widgets => {
  const cKeys = Object.keys(Model.COMPONENTS)
  const widgetsKeys = Object.keys(widgets)
  widgetsKeys.map(wk => {
    const w = widgets[wk]
    w.components.map(c => {
      const cName = `${w.name}-${c.name}`
      const sc = Model.COMPONENTS[cName]
      if (sc) {
        if (c.toggleVisibility) {
          const toggleKeys = Object.keys(c.toggleVisibility)
          toggleKeys.forEach(key => {
            if (
              c.toggleVisibility[key] &&
              c.toggleVisibility[key].fields &&
              c.toggleVisibility[key].fields.length
            ) {
              sc.toggleVisibility = c.toggleVisibility
              const fields = c.toggleVisibility[key].fields
              let tv = []
              fields.map(k => {
                //const name = `${c.widgetName}-${k}`
                cKeys.map(cName => {
                  /* if (cName.startsWith(name)) {
                    tv.push(cName)
                  } */
                  const cName_ = cName.split('-')
                  if (cName_[1] && cName_[1].startsWith(k)) {
                    tv.push(cName)
                  }
                  if (tv.length > 0) {
                    if (
                      tv.indexOf(cName) !== -1 &&
                      tv.indexOf(cName_[0]) === -1
                    ) {
                      tv.push(cName_[0])
                    }
                  }
                })
                if (k === 'S1S2' || k === 'S3S3' || k === 'S13S1') {
                  tv = tv.concat(AddressComponentList[k])
                }
              })
              if(sc.fieldId==='S8S2D1' && sc.description==='Manual entry (MOTO)')
              {
                tv.push('S12-DOCUMENTRULES')
              }
              sc.toggleVisibility[key].fields = tv
            }
          })
        }
        if (sc.name === 'S6S1D1') {
          c.isDisabled = true
          sc.isDisabled = true
        }
      }
    })
  })
  //updateWidgetToggles_(widgets, wKeys, cKeys)
}

const constructValidations = (c, f) => {
  const prop = f.properties || {}
  const validations = {}
  if (prop.mandatory /*  && f.id === 'S4S1D1' */) {
    validations.isRequired = true
    let validate
    switch (c.type) {
      case 'radio':
      case 'checkbox':
        validate = Model.VALIDATION_METHODS.bool
        break
      default:
        validate =Model.VALIDATION_METHODS.filled
    }
    validations.default = [
      {
        validate: validate,
        getErrorMessage:Model.VALIDATION_ERRORS.filled
      }
    ]
  }
  c.validations = validations
}

const cleanValue = o => (o === undefined || o === null || o === NaN ? '' : o)

const createComponent = (s, f, idx, widget) => {
  const prop = f.properties || {}
  const isActive = f.id==='S1S4D7'?true:!(s.hide || prop.hide)
  idx=f.id==='S1S4D7'?60:idx
  const c = {
    cleanName: f.title,
    position: idx,
    active: isActive,
    status: isActive ? [] : ['hidden'],
    value: cleanValue(f.value[0]),
    name: f.id,
    fieldId: f.id,
    sectionId: s.id,
    /* sectionTitle: s.title, */
    /* validations: validations, */
    type: FIELD_TYPES[f.type],
    values: [],
    /* isDisabled: prop.disabled, */
    description: f.description || '',
    errorMessage: [],
    widgetName: widget.name
  }
  if(f.type === 'LABEL' && f.id === 'S16S1D2'){
    c.fetchPromoCode = {
      url: 'OnboardRequestDetails/FetchPromoCode',
      body: {
        GUID: f.guid
      },
      mappingEvent: 'FetchPromoCode'
    }
  }
  if(f.id==='idPOSPlan')
  {
    c.fetchPosPlan = {
      url: 'OnboardRequestDetails/FetchPOSPlan',
      body: {
        GUID: f.guid
      },
      mappingEvent: 'FetchPromoCode'
    }
  }
  if(f.id==='S9S8D1' || f.id==='S9S8D2' || f.id === 'S2S8D1')
  {
    c.fullWidth=true
  }
  constructValidations(c, f)
  return c
}
export const hidesectionslist=["S2S10","S11S2","S11S0"]//,"S2S9","S2S1"]//"S1S4"(dashboardsection),
//export const sectiontitlelist=["S1S4"]
export const hidesectionsforsoftpos=(section)=>{
   //hiding the sections
   if(hidesectionslist.indexOf(section.id)>-1)
   {
    section.hide=true;
   }
   //Set the section title 
  //  if(section.id==='S1S4')
  //  {
  //   section.title="Contatti utente amministratore Dashboard"
  //  }
}
/**
 * Construct widgets from raw value data of response
 *
 * @param {Object} data             The data object to parse as widgets
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
export const parsePersonalizzaWidgets = data => (dispatch, getState) => {
  if (!(data && data.sections)) return
  let validateComponents = null;
  if(!!getState().components["PRODUCT_PLUGIN-PLUGIN_VALIDATION_ERROR"])
   {
      validateComponents=getState().components["PRODUCT_PLUGIN-PLUGIN_VALIDATION_ERROR"].rawValue.ErrorMessage
    }
    let posPlanUrl = 'OnboardRequestDetails/FetchPOSPlan';
    let posPlanBody = { GUID: getState().step.guid };
    let posPlan="";
    FetchPOSPlan(posPlanUrl, posPlanBody).then(posPlanJson => {
      const dbplan = posPlanJson && posPlanJson.payLoad && posPlanJson.payLoad.Plan && posPlanJson.payLoad.Plan.toUpperCase();
      const planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS',FLEXMINI:'flexmini' };
      posPlan = planMap[dbplan] || 'flat';
   
  const widgets = {}
  const sections = data.sections
  if (sections && sections.length > 0) {
    let idx = 0
    const addComponents = (widget, components) => {
      components.map(c => {
        Model.COMPONENTS[`${widget.name}-${c.name}`] = c
      })
    }
    const getComponent = (components, s, f, widget) => {
      if (f.id === 'S8S2D2') {
        return
      }
      const typeValues = f.typeValues
      typeValues.map(field => {
        const c = createComponent(s, f, ++idx, widget)
        c.name = f.id + field.code
        c._code = field.code
        c.description = field.description
        if (f.title && c.description === 'Do il consenso') {
          c._description = c.description
          c.description = f.title
        }
        c.value = f.value[0] === field.code ? 'selected' : ''
        const e = f.events
        if (e && e.onChange && e.onChange.length && e.onChange.length === 1) {
          /**e.onChange.length === 1 is a hack to make it work for single link */
          e.onChange.map(o => {
            if (o.valueToCheck.length) {
              const isLinked = o.valueToCheck.some(v => v === field.code)
              if (isLinked) {
                c.toggleVisibility = {}
                if (o.show.length) {
                  c.toggleVisibility.show = {
                    fields: o.show
                  }
                }
                if (o.hide.length) {
                  c.toggleVisibility.hide = {
                    fields: o.hide
                  }
                }
              }
            }
          })
        }
        components.push(c)
      })
    }
    const updateComponentProp = (components, s, f) => {
      components.map(c => {
        if(c.widgetName==='S11' || c.widgetName==='S18')
        {
          c.value=f.value
          c.validations=f.validations
          c.cleanName=f.cleanName
        }
        c.position = ++idx
        c.active = !(s.hide || f.properties.hide)
      })
      //return c
    }
    const GeneratedStateComponents = []
      let chkSelectedCount=0
      /*Promo Code */
      /*const promoCodeStaticComp = JSON.parse(
      JSON.stringify(getPromoCodeComponent())
       )       
      promoCodeStaticComp.widgets[0].components[0].fetchPromoCode= {
          url: 'https://172.17.4.63/abu_ws/OnboardRequestDetails/FetchPromoCode',
          body: {
            GUID: getState().step.guid
          },
          mappingEvent: 'FetchPromoCode'
      }
      // widget.components = [...widget.components, ...components]
      addComponents(promoCodeStaticComp.widgets[0], promoCodeStaticComp.widgets[0].components)
      widgets['PROMO'] = promoCodeStaticComp.widgets[0]
      Model.WIDGETS['PROMO'] =promoCodeStaticComp.widgets[0]
      Model.COMPONENTS = { ...Model.COMPONENTS, ...Model.WIDGETS['PROMO'].components[0]}*/
      /*PromoCOde Changes*/

    sections.map(s => {
      if (s.title === 'CONVENZIONE' && !!s.fields) {
        s.fields.unshift(getPromotionalComponent())
        s.fields[0].guid = getState().step.guid
      }
    })

    for (let i = 0; i < sections.length; i++) {
      /* Sections as Widgets */
      const s = sections[i]
      const sectionCode = getSectionCode(s.id)
      if (!sectionCode) continue
      const widgetCode = sectionCode[0]
      let widget = widgets[widgetCode]
      /*if (s.title !== null) {
      }*/
      if(s.id==="S18S1" && !!posPlan && (posPlan.toLowerCase()==='flat' || posPlan.toLowerCase()==='flex' || posPlan.toLowerCase()==='flexmini'))
      {
         s.hide=true;
      }
      hidesectionsforsoftpos(s)
      if (!widget) {
        widget = {
          name: widgetCode,
          code: widgetCode,
          group: widgetCode,
          groupTitle: s.title || '',
          errorMessage: [],
          errorMessage_: s.errorMessage || [],
          position: i,
          active: !s.hide,
          status: s.hide ? ['hidden'] : [],
          components: []
        }
      }
      widget.active = widget.active || !s.hide
      if (widget.active && widget.status.indexOf('hidden') > -1) {
        widget.status = widget.status.filter(e => e !== 'hidden')
      }
      if (
        (widget.code === 'S3' || widget.code === 'S6') &&
        getState().product.prodCode !== posProducts.prodPersonaFisica
      ) {
        widget.status = ['hidden']
        widget.active = false
      }
      const fields = s.fields
      let components = []
      for (let j = 0; j < fields.length; j++) {
        const f = fields[j]
        const type = FIELD_TYPES[f.type]
        if (
          type &&
          (type === FIELD_TYPES.RADIO || type === FIELD_TYPES.CHECKBOX) &&
          (f.typeValues && f.typeValues.length)
        ) {
          if (f.id === 'S1S0D1') {
            components.push(createSpacerComponent(f, ++idx, widget))
          }
          getComponent(components, s, f, widget)
          if (f.id === 'S1S0D1') {
            components.push(createSpacerComponent(f, ++idx, widget))
          }
          //if(f.id==='S11S0D1')
          if(widget.code==='S11' && chkSelectedCount===0)
          {
            f.value='selected'
            f.isRequired=true
            const validations = {}
            validations.isRequired = true
            let validate = Model.VALIDATION_METHODS.bool
            validations.default = [
              {
                validate: validate,
                getErrorMessage: Model.VALIDATION_ERRORS.filled
              }
            ]        
            f.validations=validations
            f.cleanName='Il consenso' //'Presa visione',
            updateComponentProp(components, s, f)
            chkSelectedCount=1
          }
          if(widget.code==='S18' && chkSelectedCount===0)
          {
            f.isRequired=true
            const validations = {}
            validations.isRequired = true
            let validate = Model.VALIDATION_METHODS.bool
            validations.default = [
              {
                validate: validate,
                getErrorMessage: Model.VALIDATION_ERRORS.filled
              }
            ]        
            f.validations=validations
            //f.cleanName='Il consenso' //'Presa visione',
            updateComponentProp(components, s, f)
            chkSelectedCount=1
          }
        } else {
          if (f.type === 'ADDRESS') {
            /** generating Components for State */
            const addressStateComponents = Model.getAddressStateComponents(
              widgetCode,
              f.id
            )
            GeneratedStateComponents.push(addressStateComponents)
            /** generating Components for widget config */
            const addressWidget = JSON.parse(
              JSON.stringify(getAddressComponents())
            )
            updateComponentProp(addressWidget.components, s, f)
            components = components.concat(addressWidget.components)
          } else {
            if (f.type === 'PHONE') {
              components.push(createSpacerComponent(f, ++idx, widget))
              let idx2 = 0
              if (!f.value.length) {
                f.value = ['', '']
              }
              for (const v of f.value) {
                const c = createComponent(s, f, ++idx, widget)
                if (idx2 === 0) {
                  c.cleanName = 'Prefisso Telefono'
                  c.description = 'PREFISSO'
                  c.type = 'selectbox'
                  c.options = {
                    url: 'wgt/utils/prefissi',
                    mapping: { label: 'description', value: 'value' }
                  }
                  c.value = v || '+39'
                  c.label = 'Italia (+39)'
                } else {
                  c.value = v
                  c.description = 'NUMERO'
                }
                c.name = f.id + idx2++
                c.value = cleanValue(c.value || v)
                components.push(c)
              }
            } else {
              const c = createComponent(s, f, ++idx, widget)
              switch (f.type) {
                case 'COMBO':
                  c.initialValue = f.value[0]
                  if (c.name === 'S6S1D1') {
                    c.value = '0'
                  }
                  if(c.name==='S1S6D1' && c.value==='')
                  {
                    c.value='00'
                    // if(getState().product.prodCode !==posProducts.prodPersonaFisica)
                    // {
                    //   //c.active=false
                    //   c.isDisabled=true
                    // }
                  }
                  if (f.typeValues && f.typeValues.length) {
                    c.values = f.typeValues.map(v => ({
                      value: v.code,
                      label: v.description
                    }))
                  }
                  if ((c.name === 'S2S1D2' && c.cleanName === 'Tipologia POS') && !!posPlan && (posPlan.toLowerCase()==='flat' || posPlan.toLowerCase()=='flatcrs')) {
                    // const telcoProduct = c.values.find(v => v.label === 'POS GPRS')
                    // const easyProduct = c.values.find(v => v.label === 'POS PAX A920')
                    const product = !!c && c.values.find(v => v.label === 'ANDROID' || v.label === 'ANDROID 920')
                    c.value = cleanValue(!!product && product.value)
                    //c.isDisabled = true
                    c.status.push('readonly')
                  } 
                  else if((c.name==='S2S1D3' && c.cleanName==='Tipologia POS') && !!posPlan && posPlan.toLowerCase()==='flexmini')
                  {
                    const product = !!c && c.values.find(v => v.label === 'ANDROIDA50')
                    c.value = cleanValue(!!product && product.value)
                    c.status.push('readonly')
                  }
                  else if((c.name==='S2S1D6' && c.cleanName==='Tipologia POS') && !!posPlan && (posPlan.toLowerCase()==='flex' || posPlan.toLowerCase()=='flexcrs'))
                  {
                    const product = !!c && c.values.find(v => v.label === 'Android A99')
                    c.value = cleanValue(!!product && product.value)
                    c.status.push('readonly')
                  }
                  else if (
                    c.name === 'S16S1D1' ||
                    widget.groupTitle === 'CONVENZIONE'
                  ) {
                    //c.values.push({ value: '203', label: 'EN Canone Flex' }); //TODO: Remove this
                    c.values = c.values.filter(v=> v.label === 'EN Canone Flat 1' || v.label === 'EN Canone Flat 2' || v.label === 'Canone Flexi' || v.label === 'Telco 4' || v.label === 'Telco 5' || v.label==='Canone Flexi 80 euro');// || v.label==='Canone Flat 3');
                    c.values = c.values.map(v => {
                      if (v.label === 'EN Canone Flat 1' || v.label === 'Telco 4') {
                        v.label = '17€ + IVA / mese, se con il tuo POS incassi meno di 10.000 euro all’anno'
                        v.currency = '17€'
                        v.vat = '+ IVA'
                        v.perMonth = 'al mese'
                        v.desc = 'Se con il tuo POS incassi meno di 10.000 euro all’anno.'
                      } else if (v.label === 'EN Canone Flat 2' || v.label === 'Telco 5') {
                        v.label = '22€ + IVA / mese, se con il tuo POS incassi tra 10.000 e 30.000 euro all’anno'
                        v.currency = '22€'
                        v.vat = '+ IVA'
                        v.perMonth = 'al mese'
                        v.desc = 'Se con il tuo POS incassi tra 10.000 e 30.000 euro all’anno'
                      } else if (v.label === 'Canone Flexi') {
                        v.label = '1% / transazione, nessun canone mensile per il tuo POS'
                        v.currency = '1%'
                        v.vat = '+ IVA'
                        v.perMonth = 'per transazione'
                        v.desc = 'Nessun canone mensile per il tuo POS'
                      }
                      return v
                    })
                    //widget.groupTitle = 'SCEGLI IL CANONE'
                  }
                case 'NUMBER':
                  if (
                    c.name === 'S2S1D1' ||
                    c.cleanName === 'Numero Terminali POS da Installare'
                    //   &&
                    // (getState().product.prodCode ===
                    //   posProducts.prodPersonaFisica ||
                    //   getState().product.prodCode === posProducts.prodDittaInd)
                  ) {
                    //c.value = 1
                    //c.status.push('readonly')
                    c.maxLength='2'
                    const validations = {}
                    validations.isRequired = true
                    let validate = Model.VALIDATION_METHODS.number  
                    validations.default = [
                      {
                        validate: validate,
                        getErrorMessage: Model.VALIDATION_ERRORS.filled
                      }
                    ]        
                    c.validations=validations
                  }
                  if(c.name==='S2S9D1')
                  {
                    c.status=['hidden']
                  }
                  if(c.name==='S18S2D1' || c.name==='S18S2D2')
                  {
                    c.maxLength=!!f.properties && f.properties.maxlength
                    const validations = {}
                    validations.isRequired = true
                    let validate = Model.VALIDATION_METHODS.number  
                    validations.default = [
                      {
                        validate: validate,
                        getErrorMessage: Model.VALIDATION_ERRORS.filled
                      }
                    ]        
                    c.validations=validations
                  }
                  updateLinkValueMap(f, c)
              } 
              if(!!validateComponents)
              {  
                 validateComponents.map(component=>{
                   if(component.field===f.id){
                    c.errorMessage[0]=component.message
                   }

                 })

              }
              components.push(c)
            }
          }
        }
        //prop.readOnly
      }      
      if(widget.code==='S15' || widget.code==='S12')
      {
        const DocumentoStepWidget = JSON.parse(
          JSON.stringify(getDocumentoRulesComponent())
       )
       DocumentoStepWidget.widgets[0].components[0].fieldId=(widget.code+'-'+DocumentoStepWidget.widgets[0].components[0].name)
       components[0].fullWidth=true
       components=[...components,...DocumentoStepWidget.widgets[0].components]
      }
      widget.components = [...widget.components, ...components]
      addComponents(widget, components)
      widgets[widgetCode] = widget
      Model.WIDGETS[widgetCode] = widget
    }
    GeneratedStateComponents.map(stateComponent => {
      Model.COMPONENTS = { ...Model.COMPONENTS, ...stateComponent }
    })
    updateWidgetToggles(widgets)
  }
  /* Constructing */
  const customJson = {
    message: 'The request is successfully served.',
    status: 'success'
  }
  customJson.step = { ...getState().step }

  const widgetsTemp = []
  if (customJson.step.widgets_ && customJson.step.widgets_.length) {
    PERSONALIZZA_WIDGETS.map(k => {
      const widgets_ = customJson.step.widgets_.find(w => w && k === w.name)
      if (widgets_) {
        widgetsTemp.push(widgets_)
      }
    })
  }
  // if(widget.code==='S8' && components[0].fieldId==='S8S2D1' &&
  // components[0].toggleVisibility && 
  // components[0].toggleVisibility.show && 
  // components[0].toggleVisibility.show.fields)
  // {
  // components[0].toggleVisibility.show.fields.concat('S12-DOCUMENTRULES')
  // }
  //const finalWidgets = ob widgets
  customJson.step.widgets = widgetsTemp.concat(Object.values(widgets))
  const token = new ActionToken('step.parsePersonalizzaWidgets')
  const oldWidgets = getState().widgets
  const oldComponents = getState().components
  dispatch(stepCallback(token, customJson, oldWidgets, oldComponents))
})
}
/**
 * Fetch data through API
 *
 * @param {Object} key          The object of a request api to fetch (optional)
 * @param {Object} component        The component to change
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 * @param {param} skipFields          The object of a request api to fetch (optional)
 */
export const sendRequest = (key, component, skipFields) => (
  dispatch,
  getState
) => {
  const { components } = getState()
  const request = component.fetch[key]
  if (
    request &&
    request.isDisabled !== false &&
    request.hasOwnProperty('url')
  ) {
    const token = new ActionToken('step.sendRequest')
    let body
    if (request.hasOwnProperty('body')) {
      body = request.body
    }
    
    if (component.id === 'DIFARMA_0-FIRMA' ||  component.id === 'DIFARMA_1-FIRMA' || component.id === 'DIFARMA_2-FIRMA' ||
    component.id === 'DIFARMA_3-FIRMA' || component.id === 'DIFARMA_4-FIRMA' || component.id === 'DIFARMA_5-FIRMA') {
    body = component.body
    }   
    if(component.id==='PROFESSIONE_ATTIVITA-PROFESSIONE' 
       || component.id==='PROFESSIONE_ATTIVITA-SETTORE'
       || component.id==='PROFESSIONE_ATTIVITA-ATTIVITA' 
       )
       {
         if(component.value!=='')
         skipFields= false
       }
    if (request.hasOwnProperty('fields') && !skipFields) {
      body = body || {}
      request.fields.forEach(field =>
        Object.keys(field).forEach(
          key => (body[field[key].fieldName] = components[key].value)
        )
      )
    }
    if (request.mappingEvent === 'titolareEffettivo' && !body.cf) {
      return
    }
    const filterDupes = arr => {
      request.mapping
        ? uniqBy(
            arr.map(o => {
              const res = o
              for (const k in request.mapping) {
                res[k] = o[request.mapping[k]]
              }
              return res
            }),
            'value'
          )
        : arr
    }
    dispatch(dealActionToken(token))
    fetchAPIData(request.url, body).then((json = []) => {
      dispatch(hideLoading())
      dispatch(dealActionToken({ ...token, dispose: true }))
      if (request.mappingEvent) {
        dispatch(updateComponentCustom(request, component, json))
      } else {
        const action = {}
        action.type = UPDATE_COMPONENT
        action.component = {
          id: component.id,
          value: component.value,
          values: filterDupes(json.data)
        }
        dispatch(action)
      }
    })
  }
}

const isNull = v => v === null
//const isNoRefId = id => id === null

 //Fix for Informazioni-compagine questionnaire checkbox validation
const constructValidationsQuest = (o /* , qo */) => {  
  if (
    o.id === 'SZ0024SS0049DM0094RI0504' ||
    o.id === 'SZ0024SS0049DM0094RI0505' || 
    o.type==='text' ||
      o.id === 'SZ0023SS0048DM0089RI0121' || 
      o.id === 'SZ0023SS0048DM0089RI1058' ||   
      o.id === 'SZ0023SS0048DM0089RI1059' || 
      o.id === 'SZ0023SS0048DM0089RI1060' || 
      o.id === 'SZ0023SS0048DM0089RI1061' || 
      o.id === 'SZ0023SS0048DM0089RI1056' ||
      o.id === 'SZ0023SS0048DM0089RI0126' || 
      o.id === 'SZ0023SS0048DM0089RI0381' ||
      o.id === 'SZ0024SS0049DM0094RI0500' || 
      o.id === 'SZ0024SS0049DM0094RI0501' ||   
      o.id === 'SZ0024SS0049DM0534RI0502' || 
      o.id === 'SZ0024SS0049DM0534RI0503' || 
      o.id === 'SZ0024SS0049DM0525RI0576' || 
      o.id === 'SZ0024SS0049DM0525RI0577' ||
      o.id==='SZ0024SS0049DM0094RI0507' ||
      o.id==='SZ0024SS0049DM0526RI0578' ||
    o.id==='SZ0016SS0011DM0030RI0103' ||
    o.id==='SZ0016SS0011DM0031RI0104' ||
    o.id==='SZ0007SS0007DM0030RI0026' ||
    o.id==='SZ0007SS0007DM0031RI0027'  ||
    o.id === 'SZ0023SS0027DM0535RI0608' ||
    o.id === 'SZ0023SS0027DM0536RI0609' ||
    o.id === 'SZ0023SS0027DM0537RI0610' ||
    o.id === 'SZ0023SS0027DM0538RI0611' ||
    o.id === 'SZ0023SS0027DM0092RI0102' ||
    o.id==='SZ0022SS0208DM0849RI0947' ||
    o.id==='SZ0022SS0208DM0849RI0948' ||
    o.id==='SZ0022SS0208DM0849RI0949' ||
    o.id==='SZ0022SS0209DM0850RI0950' ||
    o.id==='SZ0022SS0209DM0850RI0951' ||
    o.id==='SZ0011SS0230DM0886RI0989' ||
    o.id==='SZ0011SS0230DM0886RI0990' ||
    o.id==='SZ0011SS0230DM0886RI0991' ||
    o.id==='SZ0011SS0231DM0887RI0992' ||
    o.id==='SZ0011SS0231DM0887RI0993' ||
    PatrimonioCheckBoxesIds.indexOf(o.id)>-1
    // o.id==='SZ0010SS0221DM0864RI0059' ||
    // o.id==='SZ0010SS0221DM0864RI0060' ||
    // o.id==='SZ0010SS0221DM0864RI0061' ||
    // o.id==='SZ0010SS0221DM0864RI0062' ||
    // o.id==='SZ0010SS0221DM0864RI0063' ||
    // o.id==='SZ0010SS0221DM0864RI0064' ||
    // o.id==='SZ0010SS0221DM0864RI0065'
    
    //|| o.id==='SZ0144SS0237DM0959RI0791'
  ) {
    const validations = {}
    validations.isRequired = true
    let validate
    switch (o.type) {
      case 'radio':
      case 'checkbox':
      case 'selectbox':
      //case 'dropdownbox':
        validate = Model.VALIDATION_METHODS.bool
        break
      default:
        validate = Model.VALIDATION_METHODS.filled
    }
    validations.default = [
      {
        validate: validate,
        getErrorMessage: Model.VALIDATION_ERRORS.filled
      }
    ]
    o.validations = validations
  }
}

/**
 *Send OTP through API
 * 
 */

export const sendOTP=(api,body)=> (dispatch, getState) => {
  fetchAPIData(api,body).then((json = [])=>{
  })
  let updateBody={otpbtnDisabled:true}
  dispatch({
    type: UPDATE_COMPONENT,
    component: {
      ...updateBody,
      id: 'CELLULARE-NUM_CELLULARE',
    }
  }) 
  dispatch(
    updateComponent('CELLULARE-CODICE_CELLULARE', {
      isDisabled: false
    }, { avoidValidation: true })
  )
  setTimeout(function (){
    let updateBody={otpbtnDisabled:false}
    let updatedComponent = getState().components['CELLULARE-NUM_CELLULARE']
    if(updatedComponent.status.indexOf('error')<=-1)
    {
    dispatch({type:UPDATE_COMPONENT,component:{...updateBody,id: 'CELLULARE-NUM_CELLULARE',}})
    }
  }, 10000);
  
}
/**
 * Fetch data through API
 *
 * @param {Object} response         The response object contains widgets and components
 * @param {Object} config           The data fetched for the request to parse
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
export const parseQuestionarioWidgets = (response, config,prevProvincia) => (
  dispatch,
  getState
) => {
  const TYPES = {
    DropdownBox: 'selectbox',
    Radio: 'radio',
    ListBox: 'selectbox',
    Label: 'label',
    TextBox: 'text',
    CheckBox: 'checkbox',
    TextArea: 'TextArea',
    DatePicker: 'date',
    Others : 'Others'
  }
  const QUESTIONARIO_WIDGETS = [
    'FLOW_BAR',
    'SETTORE_ATTIVITA_AZIENDA',
    'AZIENDA_ANTIRICICLAGGIO',
    'PROFESSIONE_ATTIVITA',
    'ANTIRICICLAGGIO',
    'DATI_SENSIBILI',
    'CRONISTORIA',
    'PROMOZIONE',
    'PROMOZIONE_TERZI',
    'PROFILAZIONE'
  ]
  const isTitolare = config.method === 'Titolare_Effettivo'
  //try {
  /* Hack for the AZIENDA_ANTIRICICLAGGIO step */
  const section = config.data.sections.section
  const listBoxData = config.data.listBoxData
  if (config.isSavePG) {
    const jsonPG = JSON.parse(JSON.stringify(response))
    Model.savePG = jsonPG
  }
  if (section && section.length > 0) {
    Model.RefIdMap = {}
    const widgets = []
    let widget = {}
    for (const s of section) {
      /* Sections as Widgets */
      widget = {
        name: s.sectionCode,
        code: s.sectionCode,
        group: s.sectionCode,
        groupTitle: s.description.value,
        errorMessage: [],
        errorMessage_: s.errorMessage,
        position: s.sequence,
        active: isNull(s.refId),
        status:
          isNull(s.refId) &&
          s.isHidden !== true &&
          s.description.visible === true
            ? []
            : ['hidden']
      }
      const components = []
      const config = {
        sectionCode: s.sectionCode,
        position: 0
      }

      if (
        !(
          s.subSections &&
          s.subSections.subSection &&
          s.subSections.subSection.length
        )
      ) {
        continue
      }

      //let isAnyActive = false
      const subSection = s.subSections.subSection
      for (const ss of subSection) {
        /* SubSections as Component */
        const sso = {
          name: ss.subSectionCode,
          cleanName: ss.description.value,
          isSubSection: true,
          active: widget.active,
          groupConditions: {}
        }
        config.subSectionCode = ss.subSectionCode
        sso.value = ss.description.value
        updateObject(ss, sso, config)
        sso.name_ = `${s.sectionCode}-${sso.name}`

        const question = ss.questions.question
        for (const q of question) {
          /* Questions as Component */
          const qo = {
            cleanName: q.description.value,
            /*type: TYPES.Label,*/
            position: q.sequence,
            isQuestion: true,
            qCode: q.code,
            active: sso.active,
            groupCondition: q.groupCondition
          }

          updateObject(q, qo, config)
          qo.name = `${ss.subSectionCode}_${q.code}`
          qo.validations = { isRequired: q.isRequired }

          const ans = q.answers && q.answers.answer && q.answers.answer[0]
          if (
            ans &&
            ans.field &&
            (ans.field.type === 'Radio' || ans.field.type === 'Label' || ans.field.type=='Others')
          ) {
            qo.value = q.description.value
          }

          qo.name_ = `${s.sectionCode}-${qo.name}`
          let radioBtnValue = ''
          let questionID=''
          const answer = q.answers.answer
          for (const a of answer) {
            /* Answer as Component */
            const o = { ...a }
            if(!!q.description && q.description.value==='Nazione' && !o.field.value)
            {
              o.field.value='ITALIA'
            }
            if(!!q.description && q.description.value==='una Provincia' && !o.field.value)
            {
              o.field.value= !!prevProvincia?prevProvincia:o.field.value
            }
            delete o.code
            o.active = qo.active
            o.isAnswer = true
            updateObject(o, o, config)
            o.name = `${ss.subSectionCode}_${q.code}_${a.code}`
            o.type = TYPES[a.field.type]
            if (
              o.type === TYPES.ListBox ||
              o.type === TYPES.TextBox ||
              o.type === TYPES.TextArea ||
              o.type === TYPES.DatePicker
            ) {
              o.cleanName = qo.cleanName
            } else if (a.description) {
              a.cleanName = a.description
            }
            o.aCode = a.code
            o.qCode = q.code
            o.values = []
            if (
              a.field.refId &&
              o.type === TYPES.ListBox &&
              listBoxData &&
              listBoxData.list
            ) {
              const values = listBoxData.list.filter(
                v => v.refId === a.field.refId
              )
              o.values = values && values[0] && values[0].data
            }
            config.position += q.sequence
            a.position = config.position

            if (o.type === TYPES.CheckBox || o.type === TYPES.Radio) {
              if (o.type === TYPES.Radio) {
                if (!widget.radioGroup) {
                  widget.radioGroup = {}
                }
                widget.radioGroup[o.id_] = qo.id_
              }
              //o.value=
              if (radioBtnValue === '' && a.description === 'NO') {
                o.value = 'selected'
              } else {
                o.value = a.field && a.field.selected ? 'selected' : ''
                radioBtnValue = o.value
              }
              if(o.type === TYPES.Radio)
              {
              if(questionID!==qo.id_ && a.description !== 'SI')
              {
                     o.value='selected'
              }
              questionID=qo.id_
              }
              if(o.id==='SZ0023SS0048DM0089RI1056')
              {
                if(!!o.description && o.description.indexOf("vedi l'elenco dei Paesi")>-1)
                {
                let link= {
                  placeholder: '§link§',
                  text: "vedi l'elenco dei Paesi",
                  url:'https://finance.ec.europa.eu/financial-crime/high-risk-third-countries-and-international-context-content-anti-money-laundering-and-countering_en',
                  target: '_blank'
                }
                o.description="Nella compagine societaria del Cliente è presente un'entità giuridica avente sede in Paesi terzi ad alto rischio (§link§) : se si seleziona questa opzione occorre indicare la/le Nazione/i della sede dell'entità giuridica";
                o.link=link;
              }
              }

            } else if (
              o.type === TYPES.Label ||
              o.type === TYPES.TextBox ||
              o.type === TYPES.TextArea ||
              o.type === TYPES.DatePicker ||
              o.type === TYPES.ListBox
            ) {
              o.value = a.field && (a.field.value?a.field.value:"")
            }
            o.linkValue = a.field && a.field.linkValue
            o.name_ = `${s.sectionCode}-${o.name}`
            constructValidationsQuest(o, qo)
            updateRefIdMap([
              { refId: o.refId, name: o.name_, type: 'answer' },
              { refId: qo.refId, name: o.name_, type: 'answer' },
              { refId: sso.refId, name: o.name_, type: 'answer' },
              { refId: s.refId, name: o.name_, type: 'answer' },
              { refId: qo.refId, name: qo.name_, type: 'question' },
              { refId: sso.refId, name: qo.name_, type: 'question' },
              { refId: s.refId, name: qo.name_, type: 'question' },
              { refId: sso.refId, name: sso.name_, type: 'subSection' },
              { refId: s.refId, name: sso.name_, type: 'subSection' },
              { refId: s.refId, name: widget.name, type: 'section' },
              { refId: 'OB0001', name: 'SZ0023-SS0027', type: 'subSection' },
              { refId: 'OB0002', name: 'SZ0023-SS0027', type: 'subSection' }
            ])
            updateLinkIdMap(o)

            if (qo.groupCondition === 'OR' || qo.groupCondition === 'or') {
              sso.groupConditions[o.name] = qo.name
              o.isGrouped = true
            }
            Model.COMPONENTS[o.name_] = o
            components.push(o)
          }
          Model.COMPONENTS[qo.name_] = qo
          components.push(qo)
        }
        Model.COMPONENTS[sso.name_] = sso
        components.push(sso)
      }
      // if(widget.code==='SZ0016')
      // {
        let provincia=components.filter(c=>c.cleanName==='una Provincia' && !!c.field)
        let area=components.filter(c=>c.cleanName==='una Regione/Area' && !!c.field)
        let disComponentID
        if(!!provincia[0] && provincia[0].value && provincia[0].value!=='Seleziona') 
        {
          //area.isDisabled=true
          disComponentID=area[0].id
        }
        if(!!area[0] && area[0].value && area[0].value!=='Seleziona')
        {
          disComponentID=provincia[0].id
        }
        if(disComponentID)
        {
        components.map(c=>{
              if(c.id===disComponentID)
              {
                c.isDisabled=true
              }
        })
      }
      //}
      Model.WIDGETS[widget.name] = { ...widget }
      widget.components = components
      widgets.push(widget)
    }

    widgets.map(w => {
      /* toggle visibility  */
      createLinkRefMap(w)
    })

    /* Constructing */
    if (isTitolare) {
      return widgets
    } else {
      const customJson = {
        status: response.status,
        message: response.message
      }
      customJson.step = { ...getState().step }

      const widgets_temp = []
      if (customJson.step.widgets_ && customJson.step.widgets_.length) {
        QUESTIONARIO_WIDGETS.map(k => {
          const w = customJson.step.widgets_.find(w => w && k === w.name)
          if (!!w) {
            widgets_temp.push(w)
          }
        })
      }
      customJson.step.widgets = widgets_temp.concat(widgets)
      const token = new ActionToken('step.questionarioComponents')
      const oldWidgets = getState().widgets
      const oldComponents = getState().components
      dispatch(stepCallback(token, customJson, oldWidgets, oldComponents))
    }
  }
}

const updateObject = (src, dec, config) => {
  if (config) {
    dec.position = ++config.position
    dec.sectionCode = config.sectionCode
    dec.subSectionCode = config.subSectionCode
  }
  dec.errorMessage = []
  dec.id_ = src.id
  dec.refId = src.refId
  dec.linkId = src.linkId

  dec.active = dec.active && isNull(src.refId)
  dec.status = dec.active ? [] : ['hidden']
  if (
    (dec.sectionCode === 'SZ0130' &&
      (dec.subSectionCode === 'SS0033' ||
        dec.subSectionCode === 'SS0034' ||
        dec.subSectionCode === 'SS0035')) ||
    (dec.sectionCode === 'SZ0018' &&
        (dec.subSectionCode === 'SS0029' ||
          dec.subSectionCode === 'SS0003' ||
          dec.subSectionCode === 'SS0030')) ||
    (dec.sectionCode === 'SZ0023' && dec.subSectionCode === 'SS0027')
  ) {
    dec.status = false
    dec.status = ['hidden']
  }

  if (dec.isQuestion || dec.isSubSection) {
    if (src.description === null || src.description.visible === false) {
      dec.status = ['hidden']
    } else if (dec.isSubSection) {
      dec.value = src.description.value
    }
    dec.type = 'label'
  }

  dec.errorMessage_ = src.errorMessage
}

const createLinkRefMap = widget => {
  const components = widget.components
  if (components && components.length) {
    for (const c of components) {
      if (c.linkId) {
        let linkIdMap = Model.RefIdMap[c.linkId]
        if (linkIdMap) {
          linkIdMap = Object.keys(linkIdMap)
          c.toggleVisibility = {
            show: {
              fields: [...linkIdMap]
            }
          }
        }
      }
    }
    widget.components = components
  }
}

export const isLinkExist = (linkId, components) => {
  let isLinkExist_ = false
  if (linkId) {
    const linkIdMap = Model.LinkIdMap[linkId]
    if (linkIdMap) {
      const linkIdMapKey = Object.keys(linkIdMap)
      if (linkIdMapKey.length) {
        isLinkExist_ = linkIdMapKey.some(k => {
          let isLinked = false
          const c = components[k]
          if (c && c.type && c.value) {
            if (c.type === 'selectbox' || c.type === 'text') {
              isLinked = c.linkValue && c.linkValue === c.value
            } else if (c.type === 'radio' || c.type === 'checkbox') {
              isLinked = c.value === 'selected'
            }
          }
          return isLinked
        })
      }
    }
  }
  return isLinkExist_
}

const updateRefIdMap = refIdMap => {
  const linkRefIdMap = Model.RefIdMap || {}
  refIdMap.map(o => {
    if (!isNull(o.refId)) {
      if (!linkRefIdMap[o.refId]) {
        linkRefIdMap[o.refId] = {}
      }
      linkRefIdMap[o.refId][o.name] = o.type
    }
  })
  Model.RefIdMap = linkRefIdMap
}

const updateLinkIdMap = o => {
  const linkIdMap = Model.LinkIdMap || {}
  if (!isNull(o.linkId)) {
    if (!linkIdMap[o.linkId]) {
      linkIdMap[o.linkId] = {}
    }
    linkIdMap[o.linkId][o.name_] = o.type
  }
  Model.LinkIdMap = linkIdMap
}
/**
 * Fetch data through API
 *
 * @param {Object} request          The object of a request api to fetch (optional)
 * @param {Object} component        The component to change
 * @param {Object} response             The data fetched for the request
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
export const updateComponentCustom = (request, component, response) => (
  dispatch,
  getState
) => {
  //const action = {}
  const { step, product } = getState()
  const isQuestionario = request.mappingEvent === 'questionario'
  if (
    isQuestionario &&
    response &&
    response.data &&
    response.data.acolQuestionnaire
  ) {
    //action.type = QUESTIONARIO_COMPONENT
    //const customJson = {}
    //customJson.step = { ...getState().step }

    const config = {
      data: response.data.acolQuestionnaire,
      isSavePG: true
    }
    FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', { GUID:step.guid }).then((provinciaJson=[])=>{
      let prevProvincia=!!provinciaJson && !!provinciaJson.payLoad && !!provinciaJson.payLoad.Provincia?provinciaJson.payLoad.Provincia.split('-')[1]:''
      //console.log(provinciaJson.payLoad.Provincia)
      dispatch(parseQuestionarioWidgets(response, config,prevProvincia))
  })
    
    /* TODO: copy existing widgets and create components with json */
    //const token = new ActionToken('step.questionarioComponents')
    //dispatch(stepCallback(token, customJson))
    //action.components = customJson
  } else if (
    request.mappingEvent === 'titolareEffettivo' &&
    step.number === 5 &&
    product.partnership === posProducts.prodAzienda
  ) {
    if (response.data) {
      const codiceMap = new Map()
      codiceMap.set('CODICE_FISCALE-DATADINASCITA', response.data.dataDiNascita)
      codiceMap.set('CODICE_FISCALE-SESSO', response.data.sesso)
      codiceMap.set('CODICE_FISCALE-DATADINASCITA', response.data.dataDiNascita)
      codiceMap.set('CODICE_FISCALE-SESSO', response.data.sesso)
      codiceMap.set(
        'CODICE_FISCALE-PROVINCIADINASCITA',
        response.data.provinciaDiNascita
      )
      codiceMap.set(
        'CODICE_FISCALE-LUOGODINASCITA',
        !!response.data.luogoDiNascita?response.data.luogoDiNascita:response.data.statoDiNascita
      )

      codiceMap.forEach((value, key) => {
        //const value = codiceMap.get(key)
        if (key) {
          dispatch(
            updateComponent(key, {
              value: value
            })
          )
        }
      })
    }
  } else if (request.mappingEvent === 'IframeSrcSetter' && step.last) {
    if (response.data !== null) {
      const { esito, activationUrl, message } = response.data
      //var alertMessage=message.replace('<br><br>','<br/>')
      const srcUrl = activationUrl
      const callCount = 0
      if (esito.toUpperCase() === 'OK') {
        dispatch(
          updateComponent(component.updateComponentId, { value: srcUrl })
        )
        dispatch(
          showAlert({
            id: 'ATTIVA_REVOCA_FIRMA-MODAL',
            value: message,
            title: 'Messaggio'
          })
        )
        dispatch(
          updateComponent('ATTIVA_REVOCA_FIRMA-LABEL', { status: ['hidden'] })
        )
        setTimeout(dispatch(iterativeCheckCall(callCount)), timer)
      }
    }
  }
   //Digital Contract for last step
   else if (request.mappingEvent === 'DigiSignature' && step.last) {
    let action = {}
    if (response && response.status !== null && response.status === 'success') {
      action.type = UPDATE_COMPONENT
      action.component = {
        id: component.id,
        value: component.value,
        disabled: true
      }
      dispatch(updateDiFarmaComponent({}, {step:{widgets:[]}}))
    } else {

      action.type = UPDATE_COMPONENT
      action.component = {
        id: component.id,
        value: 'Firma',
        disabled: false
      }
      dispatch(action)
    }
  } 
  
  else if (request.mappingEvent === 'DiFarmaIframeSrcSetter' && step.last) {
    if (response.data !== null) {
      const { esito, url } = response.data
      const srcUrl = url
      const callCount = 0
      if (esito.toUpperCase() === 'OK') {
        dispatch(
          updateComponent(component.updateComponentId, { value: srcUrl })
        )
        setTimeout(
          dispatch(iterativeGetContractCall(component, callCount)),
          timer
        )
      }
    }
  }
}

export const activateSign = sign => dispatch => {
  if (sign.toLowerCase() === 'true') {
    dispatch(
      updateComponent('ATTIVA_REVOCA_FIRMA-VISIONE', {
        value: 'selected',
        status: ['hidden'],
        Position: 2
      })
    )
    dispatch(
      updateComponent('ATTIVA_REVOCA_FIRMA-LINK_ADDENDUM', {
        status: ['hidden']
      })
    )
    dispatch(
      updateComponent('ATTIVA_REVOCA_FIRMA-LINK_MANUALE', {
        value: `La firma digitale è un servizio gratuito che ti consente di firmare i documenti comodamente online, senza stampare.`,
        Position: 1
      })
    )
    dispatch(
      updateComponent('ATTIVA_REVOCA_FIRMA-FIRMA', {
        value: 'Attivata',
        type: 'active',
        disabled: true,
        Position: 2
      })
    )
    dispatch(
      updateComponent('ATTIVA_REVOCA_FIRMA-LINK_ISTRUZIONI', {
        value: `Per firmare i documenti usa la firma digitale SellaDigit già in tuo possesso.
        Per ulteriori informazioni su SellaDigit puoi contattare l'Assistenza al numero 800.142.142 disponibile dal lunedì al venerdì dalle 8 alle 21 (Da estero e cellulare: +39-015.2434617)`,
        Position: 3
      })
    )
    dispatch(
          updateComponent('ATTIVA_REVOCA_FIRMA-LABEL', { status: ['hidden'] })
        )
    dispatch(
      updateComponent('ATTIVA_REVOCA_FIRMA-IFRAME', { status: ['hidden'] })
    )
    dispatch(
      updateComponent('ATTIVA_REVOCA_FIRMA-LABEL', { status: ['hidden'] })
    )
  }
}

const callMaxCount = 400
const timer = 5000
const iterativeCheckCall = callCount => (dispatch, getState) => {
  digitalSignCheckCall().then(({ digitalsign }) => {
    if (digitalsign.toLowerCase() === 'true') {
      dispatch(activateSign(digitalsign))
      const { components, widgets } = getState()
      const widget = widgets.DIFARMA_0
      const component = components[`${widget.name}-FIRMA`]
      if (component !== null && widget !== null)
        dispatch(
          updateComponent(component.id, {
            disabled: false,
            type: 'sella',
            action: Object.assign(
              {},
              {
                value: 'Attivata',
                type: 'inverse',
                disabled: true,
                fetch: {
                  attivata: {
                    url: 'wgt/sign/url',
                    body: {
                      docId: component.barcode,
                      smsContent: component.tipo
                    },
                    mappingEvent: 'DiFarmaIframeSrcSetter'
                  }
                },
                updateComponentId: `${widget.name}-IFRAME`,
                toggleVisibility: {
                  show: {
                    fields: [`${widget.name}-IFRAME`]
                  }
                }
              }
            )
          })
        )
        dispatch(updateComponent("ATTIVA_REVOCA_FIRMA-IFRAME",{otpMessage:false}))
    } else {
      callCount++
      if (callCount <= callMaxCount)
        setTimeout(dispatch(iterativeCheckCall(callCount)), timer)
      else
        dispatch(
          showAlert({
            id: 'ATTIVA_REVOCA_FIRMA-MODAL',
            value: 'Errore di timeout Ricarica la pagina',
            title: 'Messaggio'
          })
        )
    }
  })
}

const iterativeGetContractCall = (component, callCount) => (
  dispatch,
  getState
) => {
  let updateFirma = null
  getContractList().then(response => {
    if (response.status.toLowerCase() === 'success') {
      const { contracts, holderInfo } = response.data
      const contractList = contracts.filter(
        ({ sign }) => sign !== '' && sign !== 'never_uploaded'
      )
      const signedContractList = contractList.filter(
        ({ sign }) => sign === 'true'
      )
      const openContract = contractList.filter(
        ({ barCode }) => barCode === component.barcode
      )
      if (!!openContract && openContract[0].sign === 'true') {
        dispatch(
          updateComponent(component.id, {
            type: 'active',
            disabled: true,
            value: 'FIRMATO',
            action: {},
            fetch: {}
          })
        )
        dispatch(
          updateComponent(component.updateComponentId, { status: ['hidden'] })
        )
        const { step } = getState()
        if (contractList.length === signedContractList.length) {
          dispatch(enableBtn(step))
        }
        let contractFirmaActive = true
        const updateContractsComponents = contractList.map(
          (contract, index) => {
            if (
              holderInfo.digitalsign &&
              contract.sign === 'false' &&
              contractFirmaActive
            ) {
              updateFirma = {
                id: `DIFARMA_${index}-${contract.azioni}`,
                update: {
                  disabled: false,
                  type: 'sella',
                  action: Object.assign(
                    {},
                    {
                      value: 'Attivata',
                      type: 'inverse',
                      disabled: true,
                      barcode: contract.barCode,
                      fetch: {
                        attivata: {
                          url: 'wgt/sign/url',
                          body: {
                            docId: contract.barCode,
                            smsContent: contract.tipo
                          },
                          mappingEvent: 'DiFarmaIframeSrcSetter'
                        }
                      },
                      updateComponentId: `DIFARMA_${index}-IFRAME`,
                      toggleVisibility: {
                        show: {
                          fields: [`DIFARMA_${index}-IFRAME`]
                        }
                      }
                    }
                  )
                }
              }
              contractFirmaActive = false
            }
          }
        )

        if (updateFirma !== null) {
          dispatch(updateComponent(updateFirma.id, updateFirma.update))
        }
      } else {
        callCount++
        if (callCount <= callMaxCount)
          setTimeout(
            dispatch(iterativeGetContractCall(component, callCount)),
            timer
          )
        else
          dispatch(
            showAlert({
              id: 'ATTIVA_REVOCA_FIRMA-MODAL',
              value: 'Errore di timeout Ricarica la pagina',
              title: 'Messaggio'
            })
          )
      }
    }
  })
}
/**
 * Fetch data through API
 *
 * @param {String} componentId      The component that updates other components
 * @param {String} api              The name of the api to fetch (optional)
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 * @param {boolean} skipFields     Skip the fields for first call
 */
export const fetchData = (componentId, api, skipFields) => (
  dispatch,
  getState
) => {
  const { components, step, product } = getState()
  const component = components[componentId]
  if (component.hasOwnProperty('fetch') && component.status.indexOf('error') < 0) {
    if (step.number === 1 && component.id === 'CODICE_FISCALE-CF') {
      return
    }
    // if (
    //   step.number === 3 &&
    //   product.prodCode === posProducts.prodPersonaFisica &&
    //   (!components['PROFESSIONE_ATTIVITA-SETTORE'].value ||
    //     !components['PROFESSIONE_ATTIVITA-PROFESSIONE'].value ||
    //     !components['PROFESSIONE_ATTIVITA-ATTIVITA'].value)
    // ) {
    //   return
    // }
    if (
      step.number === 5 &&
      product.prodCode === posProducts.prodAzienda &&
      componentId === 'SETTORE_ATTIVITA_AZIENDA-SETTORE'
    ) {
      return
    }
    if (api) {
      dispatch(sendRequest(api, component, skipFields))
    } else {
      //for (const request of component.fetch) {
      Object.keys(component.fetch).forEach(key => {
        /* we can add logic here to skip any API call based on prop */
        dispatch(sendRequest(key, component, skipFields))
      })
    }
  }
}

/**
 * Invoke a callback method
 *
 * @param {Object} config      The config to invoke a methods
 * @param {Object} component   The component to change
 * @return {Function}          Dispatches an UPDATE_COMPONENT action
 */
export const invokeMethod = (config, component) => dispatch => {
  let params = config.params || []
  params = params.map(p => component[p.name])
  dispatch(config.fn(...params))
}

/**
 * Triggers all the dependent component to get updated values
 *
 * @param {Object} componentId      The component that updates other components
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
export const triggerDependantComponents = componentId => (
  dispatch,
  getState
) => {
  const { components } = getState()
  const triggerComponent = components[componentId]
  for (const comp of triggerComponent.trigger) {
    if (Object.keys(components).indexOf(triggerComponent.id) > -1) {
      if (Object.keys(components).indexOf(comp.componentId) > -1) {
        if (
          comp.type === 'fetchOption' &&
          components[comp.componentId].type === 'selectbox'
        ) {
          const component = getState().components[comp.componentId]
          if (
            triggerComponent.id === 'PROFESSIONE_ATTIVITA-SETTORE' &&
            triggerComponent.value
          ) {
            const addOption = {
              'PROFESSIONE_ATTIVITA-SETTORE': { fieldName: 'value' }
            }
            component.options.fields.push(addOption)
          }
          //component.value = comp.value || component.value
          dispatch(getSelectOptions(component))
        } else if (comp.type === 'fetch') {
          dispatch(fetchData(comp.componentId, comp.api))
        } else if (comp.type === 'copy') {
          if (
            triggerComponent.type !== 'radio' ||
            triggerComponent.value === 'selected'
          ) {
            const value = comp.hasOwnProperty('value')
              ? comp.value
              : triggerComponent.value
            dispatch(
              updateComponent(comp.componentId, {
                value: value
              })
            )
          }
        }
      }
      if (comp.type === 'call' && comp.fn) {
        dispatch(invokeMethod(comp, triggerComponent))
      }
    }
  }
}

export const triggerGroupConditions = componentId => (dispatch, getState) => {
  const { components } = getState()
  const c = components[componentId]
  if (c.isGroupUpdate) return
  const ssoId = `${c.sectionCode}-${c.subSectionCode}`
  const sso = components[ssoId]
  //const cid = `${c.sectionCode}-${c.name}`
  let disableGroup = false
  //let iAmInside = false
  //let anotherIsNotNull = false

  if (sso && sso.groupConditions && sso.groupConditions[c.name]) {
    const isValueSelected =
      c.value !== null &&
      c.value !== undefined &&
      c.value.length > 0 &&
      c.value !== 'Seleziona'
    const grpConditons = sso.groupConditions
    Object.keys(grpConditons).forEach(key => {
      const gc = components[c.sectionCode + '-' + key]

      disableGroup = gc.id !== c.id && isValueSelected
      const isGroupUpdate = disableGroup
      if (gc.isDisabled !== disableGroup) {
        dispatch(
          updateComponent(gc.id, {
            isDisabled: disableGroup,
            isGroupUpdate
          })
        )
      }
    })
  }
}

/**
 * Notify components that they need to validate again
 *
 * @param  {type} options     Validation options
 * @return {Function}         Calls the validateComponent function
 */
export const notifyComponents = options => dispatch => {
  if (!!options && options.validate) {
    options.validate.forEach(k =>
      dispatch(validateComponent(k, { collateral: true }))
    )
  }
}

/**
 * Fills all the selects with their options
 *
 * @param {Object} component    the component to change
 * @return {Array}              all the widgets with the updated select inside
 */
export const getSelectOptions = component => (dispatch, getState) => {
  const options = component.options
  if (options.init === false || !options.hasOwnProperty('url')) return

  const { components, product } = getState()
  if (
    product.prodCode === posProducts.prodAzienda &&
    component.id === 'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA'
  ) {
    options.isDisabled = true
  }
  const filterDupes = arr =>
    uniqBy(
      arr.map(o => {
        const res = o

        for (const k in options.mapping) {
          res[k] = o[options.mapping[k]]
        }

        // @hack for residency permit
        if (options.url === 'wgt/utils/tipologiaPermessoDiSoggiorno') {
          res.enteEmissione = 'QUESTURA'
        }

        return res
      }),
      'value'
    )

  let body
  if (options.hasOwnProperty('fields')) {
    body = {}
    options.fields.forEach(field =>
      Object.keys(field).forEach(
        key =>
          components[key] &&
          (body[field[key].fieldName] = components[key].value)
      )
    )
  }
  fetchSelectOptions(options.url, body).then(json => {
    // component.fetchInProgress = false
    // if (component.showLoading) {
    //   dispatch({ type: HIDE_LOADING })
    // }
    if (component.id === 'DOCUMENTO_2-TIPO_DOCUMENTO') {
      let jsonPropertyChange = json.map(i => ({ label: i.value, value: i.code }))
      json = jsonPropertyChange
    }

    const dataArray = json ? filterDupes(json) : []
    if (
      !(
        (component.values || []).length === 0 &&
        dataArray &&
        dataArray.length === 0
      )
    ) {
      if(component.value && component.value!=='') {
        if(component && component.id && (component.id.toUpperCase()==='SETTORE_ATTIVITA_AZIENDA-SETTORE'
          || component.id.toUpperCase()==='SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA')) {
          component.value=!!dataArray.find(ow => ow.value.split("##")[0] === component.value.split("##")[0])?dataArray.find(ow => ow.value.split("##")[0] === component.value.split("##")[0]).value:'';
        }
      }
      dispatch({
        type: UPDATE_COMPONENT,
        component: {
          id: component.id,
          value:component.value,
          /* isDisabled: options.init ? component.isDisabled : options.isDisabled, */
          isLoading: false,
          values: json ? filterDupes(json) : [],
          fetchInProgress: false
        }
      })
    }
    else
    {
      if(component.id==='PROFESSIONE_ATTIVITA-PROFESSIONE' ||
    component.id==='PROFESSIONE_ATTIVITA-ATTIVITA' ||
    component.id==='PROFESSIONE_ATTIVITA-SETTORE'
    ){
      dispatch({
        type: UPDATE_COMPONENT,
        component: {
          id: component.id,
          value:'',
          /* isDisabled: options.init ? component.isDisabled : options.isDisabled, */
          isLoading: false,
          values: json ? filterDupes(json) : [],
          fetchInProgress: true
        }
      })
    }

    }
  })
}

/**
 * Fills all the address fields guessing their values from the provided zip code
 *
 * @param {Object} componentId      The component that updates other components
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
export const autoFillDependantComponents = componentId => (
  dispatch,
  getState
) => {
  const { components } = getState()
  const autofillerComponent = components[componentId]

  if (
    autofillerComponent.status.indexOf('error') < 0 &&
    !!autofillerComponent.value
  ) {
    if (!!autofillerComponent.autofill.url) {
      const body = {}

      dispatch(
        updateComponent(
          autofillerComponent.id,
          {
            autofill: { ...autofillerComponent.autofill, lastRequestId: uuid() }
          },
          {
            avoidAutofill: true,
            avoidValidation: true
          }
        )
      )

      autofillerComponent.autofill.mapping.forEach(field => {
        if (!field.excludeFromPayload) {
          body[field.key] = components[field.componentId].value
        }

        dispatch({
          type: AUTOFILL_COMPONENT_START,
          component: {
            id: field.componentId,
            status: union(getState().components[field.componentId].status, [
              'loading'
            ])
          }
        })
      })

      getAutofillValues(
        autofillerComponent.autofill.url,
        body,
        autofillerComponent.autofill.lastRequestId
      ).then(json => {
        if (json.requestId === autofillerComponent.autofill.lastRequestId) {
          if (json.data && json.data[0]) {
            for (const key in json.data[0]) {
              for (const field of autofillerComponent.autofill.mapping) {
                if (field.key === key) {
                  const delta = {
                    id: field.componentId,
                    value: json.data[0][key],
                    status: getState().components[
                      field.componentId
                    ].status.filter(v => v !== 'error' && v !== 'loading'),
                    errorMessage: []
                  }

                  if (key === 'localita') {
                    delta.values = uniqBy(
                      json.data.map(o => ({
                        ...o,
                        label: o.localita,
                        value: o.localita
                      })),
                      'value'
                    )

                    if (delta.values.length > 0) {
                      delta.isDisabled = undefined
                    }

                    if (delta.values.length > 1) {
                      if (
                        !!delta.values.find(
                          v => v.value === components[field.componentId].value
                        )
                      ) {
                        delta.value = components[field.componentId].value
                      } else {
                        delta.value = ''
                      }
                    }
                  }

                  dispatch({
                    type: AUTOFILL_COMPONENT_DONE,
                    component: delta
                  })

                  if (
                    components[field.componentId].hasOwnProperty(
                      'notifyComponents'
                    ) &&
                    Object.keys(components)
                      .map(ck => getState().components[ck])
                      .filter(
                        c =>
                          !!c.notifyComponents &&
                          c.status.indexOf('loading') > -1
                      ).length === 0
                  ) {
                    dispatch(
                      notifyComponents(
                        components[field.componentId].notifyComponents
                      )
                    )
                  }

                  break
                }
              }
            }
          } else {
            autofillerComponent.autofill.mapping.forEach(field => {
              let delta

              if (autofillerComponent.id === field.componentId) {
                delta = {
                  id: field.componentId,
                  status: [
                    ...new Set([
                      ...getState().components[field.componentId].status.filter(
                        v => v !== 'loading'
                      ),
                      'error'
                    ])
                  ],
                  errorMessage: [`${autofillerComponent.name} non valido`]
                }
              } else {
                delta = {
                  id: field.componentId,
                  status: getState().components[
                    field.componentId
                  ].status.filter(v => v !== 'loading')
                }
              }

              // @hack the value set to null is wanted to avoid typos in cap insertion
              dispatch({
                type: AUTOFILL_COMPONENT_FAILED,
                component: delta
              })
            })
          }
        } else {
          dispatch({
            type: AUTOFILL_COMPONENT_DISCARDED,
            component: autofillerComponent
          })
        }
      })
    } else {
      for (const field of autofillerComponent.autofill.mapping) {
        if (
          Object.keys(components).indexOf(field.componentId) > -1 &&
          Object.keys(components).indexOf(autofillerComponent.id) > -1
        ) {
          const autofillerOption = autofillerComponent.values.find(
            o =>
              o[!!field.key ? field.key : 'value'] === autofillerComponent.value
          )

          if (!!autofillerOption) {
            dispatch({
              type: AUTOFILL_COMPONENT_DONE,
              component: {
                id: field.componentId,
                value:
                  autofillerOption[!!field.resKey ? field.resKey : 'value'],
                status: getState().components[field.componentId].status.filter(
                  v => v !== 'error' && v !== 'loading'
                ),
                errorMessage: []
              }
            })
          }
        }
      }
    }
  }
}

/**
 * Modifies the component with the updated values
 *
 * @param {string} componentId            The name of the component to update
 * @param {Object} updateBody             An object containing the properties and values to assign to the widget
 * @param {Object} options                Update options
 * @param {Boolean} options.bypassValidation      Allows to bypass the validation process (for view init purposes)
 * @return {Function}                     Dispatches an update widget action
 */
export const updateComponent = (
  componentId,
  updateBody,
  { bypassValidation, avoidValidation, avoidAutofill, collateral } = {}
) => (dispatch, getState) => {
  if (!getState().components[componentId]) {
    return
  }
  dispatch({
    type: !collateral ? UPDATE_COMPONENT : SIDE_UPDATE_COMPONENT,
    component: {
      ...updateBody,
      id: componentId,
      dirty:
        !collateral &&
        getState().components[componentId].value !== updateBody.value &&
        !updateBody.isLoading
    }
  })
  let updatedComponent = getState().components[componentId]

  if (updatedComponent.hasOwnProperty('validations') && !avoidValidation) {
    dispatch(
      validateComponent(componentId, {
        passTrough: bypassValidation,
        evalBlanks: !!updatedComponent.dirty
      })
    )
    if( getState().step.number === 5 && getState().product.prodCode === posProducts.prodAzienda){
      dispatch(updateUserComponent())
    }
  }

  updatedComponent = getState().components[componentId]

  dispatch(triggerGroupConditions(componentId))

  if (updatedComponent.hasOwnProperty('trigger')) {
    dispatch(triggerDependantComponents(componentId))
    if( getState().step.number === 5 && getState().product.prodCode === posProducts.prodAzienda){
      dispatch(updateUserComponent())
    }
  }

  dispatch(fetchData(componentId))

  if (updatedComponent.hasOwnProperty('autofill') && !avoidAutofill) {
    dispatch(autoFillDependantComponents(componentId))
    if( getState().step.number === 5 && getState().product.prodCode === posProducts.prodAzienda){
      dispatch(updateUserComponent())
    }
  }

  if (updatedComponent.hasOwnProperty('notifyComponents')) {
    dispatch(notifyComponents(updatedComponent.notifyComponents))
    if( getState().step.number === 5 && getState().product.prodCode === posProducts.prodAzienda){
      dispatch(updateUserComponent())
    }
  }

  if (
    updatedComponent.hasOwnProperty('toggleVisibility') &&
    updatedComponent.value !== undefined &&
    updatedComponent.value !== null &&
    updatedComponent.value !== ''
  ) {
    dispatch(
      toggleVisibility(updatedComponent.toggleVisibility, updatedComponent)
    )
    const { widgets, components } = getState()
    if(!!components['SZ0022-SS0209'] )
    {
      components['SZ0022-SS0209'].status[0]='hidden';
      dispatch(updateUserComponent())
    }
    if(!!components['SZ0011-SS0231'])
    {
      components['SZ0011-SS0231'].status[0]='hidden';
      dispatch(updateUserComponent())
    }
    if( getState().step.number === 5 && getState().product.prodCode === posProducts.prodAzienda){
      
      if(
        !!widgets["TITOLARE_EFFETTIVO"] && 
        !!widgets["TITOLARE_EFFETTIVO"].status && 
        widgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation' &&
        ((!!components["TITOLARE_DATA-EFFETTIVO_SI"] && 
        components["TITOLARE_DATA-EFFETTIVO_SI"].value!=='') 
      || (!!components["TITOLARE_DATA-EFFETTIVO_NO"] && 
      components["TITOLARE_DATA-EFFETTIVO_NO"].value!=='')) 
      && !!components && !!components['SZ0025-SS0052_DM0097_RI0022'] && 
      !!components['SZ0025-SS0052_DM0097_RI0023'] &&
      !!components['SZ0025-SS0163_DM0503_RI0568'] &&
      !!components['SZ0025-SS0163_DM0503_RI0569'] &&
      !!components['TITOLARE_OWNER-EFFETTIVO_SI'] &&
      !!components['TITOLARE_OWNER-EFFETTIVO_NO'] &&
      !!components['TITOLARE_OWNER-LABEL']  && 
      !!components['SZ0025-SS0163'] &&
      !!components['SZ0025-SS0052'])
      {
        components['SZ0025-SS0052_DM0097_RI0022'].status[0]='';
        components['SZ0025-SS0052_DM0097_RI0023'].status[0]='';
        components['SZ0025-SS0163_DM0503_RI0568'].status[0]='';
        components['SZ0025-SS0163_DM0503_RI0569'].status[0]='';
        components['TITOLARE_OWNER-EFFETTIVO_NO'].status[0]='';
        components['TITOLARE_OWNER-EFFETTIVO_NO'].value='selected';
        components['TITOLARE_OWNER-EFFETTIVO_SI'].status[0]=''; 
        components['TITOLARE_OWNER-EFFETTIVO_SI'].value='';
        components['TITOLARE_OWNER-LABEL'].status[0]=''; 
        components['SZ0025-SS0163'].status[0]=''; 
        components['SZ0025-SS0052'].status[0]=''; 
      }
      dispatch(updateUserComponent())
    }
  } else if (
    updatedComponent.hasOwnProperty('toggleVisibility') &&
    (updatedComponent.linkId ||
      updatedComponent.widgetName ||
      (updatedComponent.value === '' &&
        isNoRadioSelected(getState().components, componentId) &&
        !updatedComponent.toggleVisibility.show))
  ) {
    dispatch(
      toggleVisibility(updatedComponent.toggleVisibility, updatedComponent)
    )
    if( getState().step.number === 5 && getState().product.prodCode === posProducts.prodAzienda){
      dispatch(updateUserComponent())
    }
  }
  if(updatedComponent.id==='CELLULARE-NUM_CELLULARE'){
    if (updatedComponent.value === '') {
      updatedComponent.otpbtnDisabled=true
    }
    else {
      updatedComponent.otpbtnDisabled = (updatedComponent.status.indexOf('error') > -1)
    }
  }
  if (updatedComponent.id === 'SETTORE_ATTIVITA_AZIENDA-SETTORE') {
    // const isNotSelected = !updatedComponent.value
    const componentIdToDisable =
      'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA'
    dispatch(
      updateComponent(
        componentIdToDisable,
        {
          // isDisabled: isNotSelected,
          options: {
            ...getState().components[componentIdToDisable].options,
            init: true
          }
        },
        { bypassValidation: true }
      )
    )
  }
  //@hack for residency permit
  if (updatedComponent.id === 'DOCUMENTO_2-TIPO_DOCUMENTO') {
    const isUnlimited =
      updatedComponent.value === 'CS' //|| updatedComponent.value === 'RRPS'
    const componentIdToDisable = 'DOCUMENTO_2-DATA_SCADENZA'
    dispatch(
      updateComponent(
        componentIdToDisable,
        {
          value: isUnlimited
            ? ''
            : getState().components[componentIdToDisable].value,
          isDisabled: isUnlimited,
          // status: isUnlimited ? ['hidden'] : [],
					statusStyle: isUnlimited? 'hidden': '' ,
          validations: {
            ...getState().components[componentIdToDisable].validations,
            isRequired: !isUnlimited
          }
        },
        { bypassValidation: true }
      )
    )
  }

  if( updatedComponent.id_ === 'SZ0023SS0048DM0089RI0121' || 
        updatedComponent.id_ === 'SZ0023SS0048DM0089RI1058' ||   
        updatedComponent.id_ === 'SZ0023SS0048DM0089RI1059' || 
        updatedComponent.id_ === 'SZ0023SS0048DM0089RI1060' || 
        updatedComponent.id_ === 'SZ0023SS0048DM0089RI1061' || 
        updatedComponent.id_ === 'SZ0023SS0048DM0089RI1056' || 
        updatedComponent.id_ === 'SZ0023SS0048DM0089RI0126' || 
        updatedComponent.id_ === 'SZ0023SS0048DM0089RI0381' 
      ){
    var csInfoArr = [
      'SZ0023-SS0048_DM0089_RI0121',
      //'SZ0023-SS0048_DM0089_RI0122', //Remove component RI0122 begin - end
      'SZ0023-SS0048_DM0089_RI1058', 
      'SZ0023-SS0048_DM0089_RI1059',
      'SZ0023-SS0048_DM0089_RI1060',
      'SZ0023-SS0048_DM0089_RI1061',
      'SZ0023-SS0048_DM0089_RI1056',
      'SZ0023-SS0048_DM0089_RI0126'
    ]
  
  /*@Hack for Info Legali Step*/
  // if (updatedComponent.id_ === 'SZ0023SS0048DM0089RI0381') {
  //   var isSelected = updatedComponent.value === 'selected'

  //   var csInfoArrBody = {
  //     //validations : {isRequired: true}, //{isRequired: !isSelected},
  //     value: '',
  //     isDisabled: isSelected
  //   }
    
  //     csInfoArr.forEach(cid => {
  //       dispatch(
  //         updateComponent(
  //           cid,
  //           csInfoArrBody,
  //           { bypassValidation: true }
  //         )
  //       )
  //     })
  //   }  

  }
  
  /* Informazioni_compagine_societaria */
  const Informazioni_compagine = [
      'SZ0023-SS0048_DM0089_RI0121',
      'SZ0023-SS0048_DM0089_RI1058', 
      'SZ0023-SS0048_DM0089_RI1059',
      'SZ0023-SS0048_DM0089_RI1060',
      'SZ0023-SS0048_DM0089_RI1061',
      'SZ0023-SS0048_DM0089_RI1056',
      'SZ0023-SS0048_DM0089_RI0126',
      'SZ0023-SS0048_DM0089_RI0381'
  ]
  const TITOLARE_EFFETTIVO = [
    'SZ0024-SS0049_DM0094_RI0504',
    'SZ0024-SS0049_DM0094_RI0505'
  ]
  if (Informazioni_compagine.indexOf(updatedComponent.id) > -1) {
    const components = getState().components
    const iCArr = Informazioni_compagine
    const c1 = components[iCArr[0]]
    const c2 = components[iCArr[1]]
    //const c3 = components[iCArr[2]] //Remove component RI0122 begin - end
    var csGroup1 = {}
    csGroup1[TITOLARE_EFFETTIVO[0]] = c1.value === 'selected'
    csGroup1[TITOLARE_EFFETTIVO[1]] =
      ((!!c1 && !!c1.value && c1.value === 'selected') && (!!c2 && !!c2.value && c2.value === 'selected')) //Remove component RI0122 begin - end
    if (csGroup1) {
      const isTitolareEffettivoVisible = Object.keys(csGroup1).every(k => csGroup1[k])
      csGroup1['SZ0024-SS0049'] = isTitolareEffettivoVisible
      csGroup1['SZ0024-SS0049_DM0094'] = isTitolareEffettivoVisible
      if (isTitolareEffettivoVisible) {
        dispatch(updateWidget('SZ0024', { active: false, status: ['hidden'] }))
      } else {
        dispatch(updateWidget('SZ0024', { active: true, status: [] }))
      }
    }
    Object.keys(csGroup1).forEach(k => {
      const isSelected_ = csGroup1[k]
      const status = !!components[k] && !!components[k].status && components[k].status.filter(v => v !== 'hidden')
      dispatch(
        updateComponent(
          k,
          {
            active: !isSelected_,
            status: isSelected_ ? [...status, 'hidden'] : status
          },
          { bypassValidation: true }
        )
      )
    })
  }
  /*  if (updatedComponent.id === 'TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA') {
  }*/
  const TIPO_DOCUMENTO_OPTION = {
    "Carta d'identita": 'DOCUMENTO_2-CARTA_IDENTITA',
    Passaporto: 'DOCUMENTO_2-PASSAPORTO',
    'Patente di guida': 'DOCUMENTO_2-PATENTE'
  }
  if (
    updatedComponent.id === 'DOCUMENTO-TIPO_DOCUMENTO' &&
    getState().components['DOCUMENTO_2-CARTA_IDENTITA']
  ) {
    const components = getState().components
    const uC = updatedComponent
    const isSelected = uC && uC.value
    const doc2ComponentId = isSelected && TIPO_DOCUMENTO_OPTION[uC.value]
    Object.values(TIPO_DOCUMENTO_OPTION).forEach(v => {
      const doc2Component = components[v]
      if (doc2Component) {
        let isUpdate = false
        let isDisabled = true
        if (doc2ComponentId && v === doc2ComponentId) {
          isUpdate = true
          isDisabled = true
        } else if (doc2Component.status.indexOf('readonly') > -1) {
          isUpdate = true
          isDisabled = false
        }

        if (isUpdate && v) {
          const status = doc2Component.status
            ? doc2Component.status.filter(e => e !== 'readonly')
            : []
          dispatch(
            updateComponent(
              v,
              {
                value: '',
                status: isDisabled ? [...status, 'readonly'] : status
              },
              { bypassValidation: true }
            )
          )
        }
      }
    })
  }
}

export const updateFilePreview = component => (dispatch, getState) => {
  const { step, product, components } = getState()
  const token = new ActionToken(`${component.id}.updateFilePreview`, true)
  // const extraBody = {
  //   type: '',
  //   docRefId: '',
  //   widgetId: '',
  //   docType: ''
  // }
  let extraBody = {}
  if (step.number === 5 && product.partnership === posProducts.prodAzienda) {
    extraBody = {
      type: '',
      docRefId: '',
      widgetId: '',
      docType: ''
    }
    if (step.widgets_ && step.widgets_.length) {
      const widgets_ = step.widgets_.find(
        w => w && w.name === 'TITOLARE_EFFETTIVO'
      )
      if (widgets_) {
        extraBody.widgetId = widgets_.code
      }
    }
    const comp = components['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA']
    if (
      comp &&
      comp.rawValue &&
      comp.rawValue.titolare_effettivo[0].documento &&
      comp.rawValue.titolare_effettivo[0].documento.doc_ref_id
    ) {
      extraBody.docRefId =
        comp.rawValue.titolare_effettivo[0].documento.doc_ref_id
      extraBody.docType = comp.rawValue.titolare_effettivo[0].documento.doc_type
      extraBody.type = component.uploadType.startsWith('FRONT')
        ? 'FRONT'
        : 'BACK'
    }
  } else if (
    (step.number === 6 && product.partnership === posProducts.prodAzienda) ||
    (step.number === 4 &&
      product.partnership === posProducts.prodPersonaFisica) ||
    (step.number === 5 && product.partnership === posProducts.prodDittaInd)
  ) {
    extraBody = {
      type: '',
      docRefId: '',
      widgetId: '',
      docType: ''
    }

    const PRODUCT_PLUGIN =
      step.config && step.config.widget && step.config.widget.PRODUCT_PLUGIN
    if (PRODUCT_PLUGIN) {
      extraBody.widgetId = PRODUCT_PLUGIN.code
    }
    extraBody.type = 'FRONT'
  }
  dispatch(dealActionToken(token))
  getFilePreview(component, extraBody).then(url => {
    dispatch(updateComponent(component.id, { value: url }))
    dispatch(dealActionToken({ ...token, dispose: true }))
  })
}

/**
 * Uploads a file
 * @public
 *
 * @param {Object} component     The uploader component
 * @return {Promise}             promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
export const uploadFile = (component, file) => (dispatch, getState) => {
  file = file || {}
  const token = new ActionToken('step.uploadFile', true)
  let extraBody = {}
  const { step, product, components } = getState()
  dispatch(dealActionToken(token))
  dispatch(updateComponent(component.id, { isLoading: true }))

  if (step.number === 5 && product.partnership === posProducts.prodAzienda) {
    extraBody = {
      type: '',
      docRefId: '',
      widgetId: '',
      docType: 'TEDOC'
    }
    extraBody.type = component.uploadType.startsWith('FRONT') ? 'FRONT' : 'BACK'
    const compName =
      component.name === 'DOCF_UPLOAD' ? 'DOCF_UPLOAD' : 'DOCR_UPLOAD'
    if (compName) {
      const uComp = step.titolareList.filter(o => o.open)
      extraBody.titoComp = uComp
      const compId = 'DOCUMENTO-' + compName
      //const compId = 'DOCUMENTO-DOCF_UPLOAD'
      extraBody.compId = compId
      const ref_id = compId
        ? //? uComp[0].userComponents['DOCUMENTO-DOCF_UPLOAD'].docRefId
          uComp[0].dcRfId
        : null
      extraBody.docRefId = ref_id
        ? ref_id
        : '' + Math.floor(Math.random() * 100000000 + 1)
    }

    if (step.widgets_ && step.widgets_.length) {
      const widgets_ = step.widgets_.find(
        w => w && w.name === 'TITOLARE_EFFETTIVO'
      )
      if (widgets_) {
        extraBody.widgetId = widgets_.code
      }
    }
  }
  if (
    (step.number === 6 && product.partnership === posProducts.prodAzienda) ||
    (step.number === 4 &&
      product.partnership === posProducts.prodPersonaFisica) ||
    (step.number === 5 && product.partnership === posProducts.prodDittaInd)
  ) {
    extraBody = {
      type: 'FRONT',
      widgetId: '',
      docType: 'POS_EN'
    }
    extraBody.docRefId = component.sectionId + '##' + component.fieldId
    const PRODUCT_PLUGIN =
      step.config && step.config.widget && step.config.widget.PRODUCT_PLUGIN
    if (PRODUCT_PLUGIN) {
      extraBody.widgetId = PRODUCT_PLUGIN.code
    }
  }
  //Changes for loading new widget
  if (step.number === 6 && product.partnership === posProducts.prodDittaInd && component.id==='DOCUMENTO_GENERICO-DOC_UPLOAD')
  {
    extraBody = {
      type: 'FRONT_DOC_',
      widgetId: '',
    }
    if (step.widgets_ && step.widgets_.length) {
      const widgets_ = step.widgets_.find(
        w => w && w.name === 'DOCUMENTO_GENERICO'
      )
      if (widgets_) {
        extraBody.widgetId = widgets_.code
      }
    }

  }
  return postFile(
    file,
    component.value,
    component.uploadType,
    component.guid, // only present in re-upload
    component.barCode, // only present in re-upload
    extraBody //only present for titolare_effective step
  )
    .then(json => {
      if (json.status === 'success') {
        if (!!component.guid && !!component.barCode) {
          dispatch(
            updateComponent(component.id, {
              value: component.value,
              isLoading: false
            })
          )
          dispatch(dealActionToken({ ...token, dispose: true }))
        } else {
          getFilePreview(component, extraBody).then(url => {
            if (
              step.number === 5 &&
              product.partnership === posProducts.prodAzienda &&
              !!extraBody.compId
            ) {
              step.titolareList.map(u => {
                if (u.id === extraBody.titoComp[0].id) {
                  u.userComponents[extraBody.compId].value =
                    component.value || url
                  u.userComponents[extraBody.compId].isLoading = false
                  u.userComponents[extraBody.compId].docRefId =
                    extraBody.docRefId
                  u.userComponents[extraBody.compId].fileName = file.name
                  u.dcRfId = extraBody.docRefId
                }
                step.titolareList[u.id] = u
              })
              dispatch(updateTitolareList(step.titolareList))
              dispatch(
                updateComponent(component.id, {
                  value: (file.type==='application/pdf')?`${CONTEXT_ROOT}/assets/images/upload_pdf_doc.png`:component.value || url,
                  isLoading: false,
                  docRefId: extraBody.docRefId,
                  fileName: file.name
                })
              )
            } else {
              dispatch(
                updateComponent(component.id, {
                  value: (file.type==='application/pdf')?`${CONTEXT_ROOT}/assets/images/upload_pdf_doc.png`:component.value || url,
                  isLoading: false,
                  docRefId: extraBody.docRefId,
                  fileName: file.name
                })
              )
            }

            dispatch(dealActionToken({ ...token, dispose: true }))
          })
        }
      } else throw json
    })
    .catch(json => {
      dispatch(
        updateComponent(
          component.id,
          {
            value: '',
            errorMessage: json.message,
            status: union(component.status, [json.status]),
            isLoading: false
          },
          { avoidValidation: true }
        )
      )
      dispatch(dealActionToken({ ...token, dispose: true }))
      // dispatch(handleServerErrors(json))
    })
}
/**
 * Sends an OTP to the provided email
 * @public
 * @param  {Object} component    the component containing the email to verify
 * @return {Promise}             otp delivery promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
export const sendEmailOtp = component => (/*dispatch*/) => {
  return sendOtp('EMAIL', component.value)
}

/**
 * Sends an OTP to the provided mobile
 * @public
 * @param  {Object} component    the component containing the mobile to verify
 * @return {Promise}             otp delivery promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
export const sendSmsOtp = component => (/*dispatch*/) => {
  return sendOtp('MOBILE', component.value)
}

export const tweakAgreement = ({
  widget,
  force,
  hide,
  forceValue = 'selected',
  description
}) => (dispatch, getState) => {
  const { components } = getState()
  if (!!hide) {
    dispatch(updateWidget(widget.name, { status: ['hidden'] }))
  }
  const ck = `${widget.name}-VISIONE`
  if (components[ck].status.indexOf('selected') > -1 || !!force) {
    dispatch(
      updateComponent(
        ck,
        {
          value: !!force ? forceValue : 'selected',
          description: !!description ? description : components[ck].description
        },
        { bypassValidation: true }
      )
    )
  }
}



// WEBPACK FOOTER //
// ./state/actions/componentsActions.js